(function () {
  if (window.__LOOP_AUTOADDONS__) {
    return;
  }
  window.__LOOP_AUTOADDONS__ = true;
  window.__LOOP_AUTOADDONS_LOADED_AT__ = Date.now();
  window.__LOOP_AUTOADDONS_SWEET_STEP_ACTIVE = false;
  window.__LOOP_AUTOADDONS_INITIAL_APPLY_DONE = false;

  var DEFAULT_CONFIG = {
    enabled: true,
    rootSelector: ".loop-bs-container",
    bundleIdSelector: "[data-loop-bundle-id], [data-bundle-id], [data-bundle]",
    cardSelector: ".loop-bundle-product-card[data-product-handle]",
    cardWrapSelector: ".loop-bundle-product-wrapper",
    sizeSelector:
      ".loop-box-size-selector .loop-btn-selected, .loop-bundle-size-selector .loop-btn-selected, .loop-btn-selected[aria-current='true']",
    sizeClickSelector:
      ".loop-box-size-selector .loop-btn, .loop-bundle-size-selector .loop-btn, [data-loop-bundle-size], [data-bundle-size], [data-size]",
    addButtonSelector: ".loop-btn-add-product",
    increaseButtonSelector: ".loop-btn-input-increase",
    quantityInputSelector: ".loop-bundle-product-quantity-controls input, input.loop-form-input[id^='quantity-']",
    frequencyButtonSelector:
      ".loop-bundle-widget-frequency-interval-button, .loop-bundle-widget-frequency-interval-items",
    frequencySelectedClass: "selected",
    frequencyStorageKeyPrefix: "loop:autoaddons:frequency",
    frequencyRestoreDelayMs: 180,
    loadingClass: "loop-autoaddons-loading",
    allowedSizes: [10, 15, 18, 21],
    defaultBundleSize: 0,
    requireBundleRule: true,
    bundleRules: [],
    fallbackToSizeTags: false,
    tagPrefix: "Auto_Add",
    prioritySuffix: "Priority",
    clickDelayMs: 60,
    actionTimeoutMs: 1500,
    retryLimit: 160,
    bootstrapDelayMs: 200,
    mutationDebounceMs: 120,
    sweetsStepEnabled: true,
    hideSweetsUntilStep: true,
    sweetsStepTriggerSelector: ".loop-bundle-widget-add-to-cart-container .loop-btn-add-to-cart",
    sweetsVariantIds: [
      "46310329614593",
      "46767604793601",
      "46767604957441",
      "46782304518401",
      "46310330761473",
      "46089986572545",
      "46767604334849",
      "46310330466561",
      "46782302093569"
    ],
    sweetsAutoSelectVariantIds: ["46310329614593", "46767604793601", "46767604957441"],
    sweetsFreeVariantId: "46782304551169",
    alwaysHiddenVariantIds: ["46123231019265"],
    sweetsRequiredCount: 3,
    sweetsScrollOffsetPx: 0,
    sweetsScrollSettleDelayMs: 260,
    sweetsScrollFinalDelayMs: 520,
    sweetCheckoutBusyMs: 5500,
    closeMobileBottomSheetOnSweetStep: true,
    mobileBreakpointPx: 991,
    bottomSheetCloseSelector:
      ".react-modal-sheet-container.loop-bottom-sheet .loop-bottom-sheet-header-icon[aria-label='Close'], .react-modal-sheet-container.loop-bottom-sheet .loop-bottom-sheet-header-icon",
    bottomSheetContainerSelector: ".react-modal-sheet-container.loop-bottom-sheet",
    sweetsTreatPriceText: "$1.25 / Treat",
    sweetsTitle: "Don't Forget Something Sweet",
    sweetsSubtitle: "Add 3 sweets and unlock a free Dubai Chocolate Brownie Cheesecake",
    sweetsProductToVariantMap: {
      "8792368775425": "46310329614593",
      "8920080154881": "46767604793601",
      "8920080318721": "46767604957441",
      "8924479389953": "46782304551169"
    }
  };

  var state = {
    applying: false,
    observerStarted: false,
    retryCount: 0,
    scheduledTimer: null,
    defaultVisibilityTimer: null,
    visibilityApplying: false,
    productByHandle: {},
    productPromiseByHandle: {},
    applyStampBySize: {},
    noRuleLoggedByStamp: {},
    userInteracted: false,
    sweetStepShown: false,
    sweetStepInterceptUntil: 0,
    sweetSyncTimer: null,
    sweetAutoSelectTimer: null,
    sweetAutoSelectDone: false,
    sweetSyncRunning: false,
    sweetBonusApplying: false,
    sweetBonusUnlocked: null,
    sweetCheckoutProxyBusyUntil: 0,
    frequencySafeDisabled: false,
    frequencyRestoreTimer: null,
    frequencyBurstTimers: [],
    frequencyRestoreInFlight: false,
    frequencyLastAppliedToken: "",
    frequencyLastAppliedAt: 0
  };

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function normalize(value) {
    return String(value || "")
      .toLowerCase()
      .replace(/&/g, " and ")
      .replace(/[^a-z0-9]+/g, "");
  }

  function hasOwn(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
  }

  function setAnyIntersect(firstSet, secondSet) {
    for (var key in firstSet) {
      if (hasOwn(firstSet, key) && secondSet[key]) return true;
    }
    return false;
  }

  function setSize(setObj) {
    var count = 0;
    for (var key in setObj) {
      if (hasOwn(setObj, key)) count += 1;
    }
    return count;
  }

  function splitTagValues(value) {
    return String(value || "")
      .split(/[|,]/)
      .map(function (item) {
        return normalize(item);
      })
      .filter(Boolean);
  }

  function listToSet(list) {
    var setObj = {};
    for (var i = 0; i < list.length; i += 1) {
      setObj[list[i]] = true;
    }
    return setObj;
  }

  function parseBundleSize(value) {
    if (value === null || value === undefined || value === "") return 0;
    var parsed = parseInt(value, 10);
    return isNaN(parsed) || parsed <= 0 ? 0 : parsed;
  }

  function parseBundleRule(rule) {
    if (!rule) return null;
    var bundleId = String(rule.bundleId || rule.bundle_id || "").trim().toLowerCase();
    if (!bundleId) return null;

    var size = parseBundleSize(rule.bundleSize || rule.bundle_size || rule.size);
    var maxTotal = parseBundleSize(
      rule.maxTotal || rule.max_total || rule.totalLimit || rule.total_limit || rule.limit || rule.maxMeals || rule.max_meals
    );
    var standardTags = splitTagValues(rule.standardTag || rule.standard_tag || rule.tag || "");
    var priorityTags = splitTagValues(rule.priorityTag || rule.priority_tag || "");
    if (!standardTags.length && !priorityTags.length) return null;

    return {
      bundleId: bundleId,
      bundleSize: size,
      maxTotal: maxTotal,
      standardTags: standardTags,
      standardTagSet: listToSet(standardTags),
      priorityTags: priorityTags,
      priorityTagSet: listToSet(priorityTags)
    };
  }

  function buildBundleRules(rawRules) {
    var list = Array.isArray(rawRules) ? rawRules : [];
    var parsed = [];
    var byId = {};

    for (var i = 0; i < list.length; i += 1) {
      var rule = parseBundleRule(list[i]);
      if (!rule) continue;
      parsed.push(rule);
      if (!byId[rule.bundleId]) byId[rule.bundleId] = [];
      byId[rule.bundleId].push(rule);
    }

    return {
      list: parsed,
      byId: byId
    };
  }

  function normalizeVariantId(value) {
    var raw = String(value || "").trim();
    if (!raw) return "";
    var digits = raw.match(/\d+/g);
    return digits && digits.length ? digits.join("") : raw;
  }

  function parseVariantIdList(value) {
    var source = [];
    if (Array.isArray(value)) {
      source = value;
    } else {
      source = String(value || "").split(/[,\n|]/);
    }
    var out = [];
    var seen = {};
    for (var i = 0; i < source.length; i += 1) {
      var normalized = normalizeVariantId(source[i]);
      if (!normalized || seen[normalized]) continue;
      seen[normalized] = true;
      out.push(normalized);
    }
    return out;
  }

  function normalizeVariantMap(value) {
    var out = {};
    if (!value || typeof value !== "object") return out;
    for (var key in value) {
      if (!hasOwn(value, key)) continue;
      var normalizedKey = normalizeVariantId(key);
      var normalizedValue = normalizeVariantId(value[key]);
      if (!normalizedKey || !normalizedValue) continue;
      out[normalizedKey] = normalizedValue;
    }
    return out;
  }

  function remapIdsByVariantMap(list, variantMap) {
    var mapped = [];
    var seen = {};
    var source = Array.isArray(list) ? list : [];
    for (var i = 0; i < source.length; i += 1) {
      var raw = normalizeVariantId(source[i]);
      if (!raw) continue;
      var finalId = variantMap[raw] || raw;
      if (seen[finalId]) continue;
      seen[finalId] = true;
      mapped.push(finalId);
    }
    return mapped;
  }

  function mapOneIdByVariantMap(value, variantMap) {
    var raw = normalizeVariantId(value);
    if (!raw) return "";
    return variantMap[raw] || raw;
  }

  function mergeConfig(rawConfig) {
    var out = {};
    var key;
    for (key in DEFAULT_CONFIG) {
      if (hasOwn(DEFAULT_CONFIG, key)) out[key] = DEFAULT_CONFIG[key];
    }
    for (key in rawConfig) {
      if (hasOwn(rawConfig, key) && rawConfig[key] !== null && rawConfig[key] !== "") {
        out[key] = rawConfig[key];
      }
    }

    if (typeof out.allowedSizes === "string") {
      out.allowedSizes = out.allowedSizes
        .split(",")
        .map(function (item) {
          return parseInt(item, 10);
        })
        .filter(function (num) {
          return !isNaN(num) && num > 0;
        });
    } else if (Array.isArray(out.allowedSizes)) {
      out.allowedSizes = out.allowedSizes
        .map(function (item) {
          return parseInt(item, 10);
        })
        .filter(function (num) {
          return !isNaN(num) && num > 0;
        });
    } else {
      out.allowedSizes = DEFAULT_CONFIG.allowedSizes.slice();
    }

    out.allowedSizeSet = {};
    for (var i = 0; i < out.allowedSizes.length; i += 1) {
      out.allowedSizeSet[out.allowedSizes[i]] = true;
    }

    out.defaultBundleSize = parseInt(out.defaultBundleSize, 10) || 0;
    out.requireBundleRule = out.requireBundleRule !== false;
    out.fallbackToSizeTags = out.fallbackToSizeTags === true;
    out.clickDelayMs = parseInt(out.clickDelayMs, 10) || DEFAULT_CONFIG.clickDelayMs;
    out.actionTimeoutMs = parseInt(out.actionTimeoutMs, 10) || DEFAULT_CONFIG.actionTimeoutMs;
    out.retryLimit = parseInt(out.retryLimit, 10) || DEFAULT_CONFIG.retryLimit;
    out.bootstrapDelayMs = parseInt(out.bootstrapDelayMs, 10) || DEFAULT_CONFIG.bootstrapDelayMs;
    out.mutationDebounceMs = parseInt(out.mutationDebounceMs, 10) || DEFAULT_CONFIG.mutationDebounceMs;
    out.sweetsStepEnabled = out.sweetsStepEnabled !== false;
    out.hideSweetsUntilStep = out.hideSweetsUntilStep !== false;
    out.sweetsStepTriggerSelector = String(out.sweetsStepTriggerSelector || DEFAULT_CONFIG.sweetsStepTriggerSelector);
    out.sweetsProductToVariantMap = normalizeVariantMap(out.sweetsProductToVariantMap || DEFAULT_CONFIG.sweetsProductToVariantMap);
    out.sweetsVariantIds = remapIdsByVariantMap(parseVariantIdList(out.sweetsVariantIds), out.sweetsProductToVariantMap);
    var defaultSweetIds = remapIdsByVariantMap(DEFAULT_CONFIG.sweetsVariantIds, out.sweetsProductToVariantMap);
    out.sweetsVariantIds = out.sweetsVariantIds.length
      ? remapIdsByVariantMap(out.sweetsVariantIds.concat(defaultSweetIds), out.sweetsProductToVariantMap)
      : defaultSweetIds.slice();
    out.sweetsAutoSelectVariantIds = remapIdsByVariantMap(
      parseVariantIdList(out.sweetsAutoSelectVariantIds),
      out.sweetsProductToVariantMap
    );
    if (!out.sweetsAutoSelectVariantIds.length) {
      out.sweetsAutoSelectVariantIds = out.sweetsVariantIds.slice(0, 3);
    }
    out.sweetsAutoSelectVariantIdSet = listToSet(out.sweetsAutoSelectVariantIds);
    out.sweetsVariantIdSet = listToSet(out.sweetsVariantIds);
    out.sweetsFreeVariantId =
      mapOneIdByVariantMap(out.sweetsFreeVariantId, out.sweetsProductToVariantMap) ||
      mapOneIdByVariantMap(DEFAULT_CONFIG.sweetsFreeVariantId, out.sweetsProductToVariantMap);
    out.alwaysHiddenVariantIds = parseVariantIdList(out.alwaysHiddenVariantIds);
    if (!out.alwaysHiddenVariantIds.length) {
      out.alwaysHiddenVariantIds = DEFAULT_CONFIG.alwaysHiddenVariantIds.slice();
    }
    out.alwaysHiddenVariantIdSet = listToSet(out.alwaysHiddenVariantIds);
    out.sweetsRequiredCount = parseInt(out.sweetsRequiredCount, 10) || DEFAULT_CONFIG.sweetsRequiredCount;
    if (out.sweetsRequiredCount < 1) out.sweetsRequiredCount = 1;
    out.sweetsScrollOffsetPx = parseInt(out.sweetsScrollOffsetPx, 10);
    if (isNaN(out.sweetsScrollOffsetPx)) out.sweetsScrollOffsetPx = DEFAULT_CONFIG.sweetsScrollOffsetPx;
    out.sweetsScrollSettleDelayMs = parseInt(out.sweetsScrollSettleDelayMs, 10);
    if (isNaN(out.sweetsScrollSettleDelayMs) || out.sweetsScrollSettleDelayMs < 0) {
      out.sweetsScrollSettleDelayMs = DEFAULT_CONFIG.sweetsScrollSettleDelayMs;
    }
    out.sweetsScrollFinalDelayMs = parseInt(out.sweetsScrollFinalDelayMs, 10);
    if (isNaN(out.sweetsScrollFinalDelayMs) || out.sweetsScrollFinalDelayMs < 0) {
      out.sweetsScrollFinalDelayMs = DEFAULT_CONFIG.sweetsScrollFinalDelayMs;
    }
    out.sweetCheckoutBusyMs = parseInt(out.sweetCheckoutBusyMs, 10);
    if (isNaN(out.sweetCheckoutBusyMs) || out.sweetCheckoutBusyMs < 400) {
      out.sweetCheckoutBusyMs = DEFAULT_CONFIG.sweetCheckoutBusyMs;
    }
    out.closeMobileBottomSheetOnSweetStep = out.closeMobileBottomSheetOnSweetStep !== false;
    out.mobileBreakpointPx = parseInt(out.mobileBreakpointPx, 10);
    if (isNaN(out.mobileBreakpointPx) || out.mobileBreakpointPx < 320) {
      out.mobileBreakpointPx = DEFAULT_CONFIG.mobileBreakpointPx;
    }
    out.bottomSheetCloseSelector = String(out.bottomSheetCloseSelector || DEFAULT_CONFIG.bottomSheetCloseSelector);
    out.bottomSheetContainerSelector = String(out.bottomSheetContainerSelector || DEFAULT_CONFIG.bottomSheetContainerSelector);
    out.sweetsTreatPriceText = String(out.sweetsTreatPriceText || DEFAULT_CONFIG.sweetsTreatPriceText);
    out.sweetsTitle = String(out.sweetsTitle || DEFAULT_CONFIG.sweetsTitle);
    out.sweetsSubtitle = String(out.sweetsSubtitle || DEFAULT_CONFIG.sweetsSubtitle);
    out.frequencyButtonSelector = String(out.frequencyButtonSelector || DEFAULT_CONFIG.frequencyButtonSelector);
    out.frequencySelectedClass = String(out.frequencySelectedClass || DEFAULT_CONFIG.frequencySelectedClass);
    out.frequencyStorageKeyPrefix = String(out.frequencyStorageKeyPrefix || DEFAULT_CONFIG.frequencyStorageKeyPrefix);
    out.frequencyRestoreDelayMs = parseInt(out.frequencyRestoreDelayMs, 10);
    if (isNaN(out.frequencyRestoreDelayMs) || out.frequencyRestoreDelayMs < 0) {
      out.frequencyRestoreDelayMs = DEFAULT_CONFIG.frequencyRestoreDelayMs;
    }

    var rules = buildBundleRules(out.bundleRules);
    out.bundleRules = rules.list;
    out.bundleRulesById = rules.byId;

    return out;
  }

  function getRuntimeConfig() {
    var queue = window.LoopAutoAddonsConfig;
    var raw = queue && queue.length ? queue[queue.length - 1] : {};
    return mergeConfig(raw || {});
  }

  function isGlobalDebugEnabled() {
    return false;
  }

  function log() {}

  function trace() {}

  function isDebugEnabled() {
    return false;
  }

  function debugGroupStart() {
    return false;
  }

  function debugGroupEnd() {}

  function setToList(setObj) {
    var out = [];
    for (var key in setObj) {
      if (hasOwn(setObj, key) && setObj[key]) out.push(key);
    }
    return out;
  }

  function runFrequencySafe(task) {
    try {
      return task();
    } catch (_e) {
      return false;
    }
  }

  function closestSafe(target, selector) {
    if (!target || !target.closest || !selector) return null;
    try {
      return target.closest(selector);
    } catch (_e) {
      return null;
    }
  }

  function mergeClassNames() {
    var out = [];
    var seen = {};
    for (var i = 0; i < arguments.length; i += 1) {
      var source = String(arguments[i] || "").split(/\s+/);
      for (var n = 0; n < source.length; n += 1) {
        var name = source[n];
        if (!name || seen[name]) continue;
        seen[name] = true;
        out.push(name);
      }
    }
    return out.join(" ");
  }

  function setIntersectList(firstSet, secondSet) {
    var out = [];
    if (!firstSet || !secondSet) return out;
    for (var key in firstSet) {
      if (hasOwn(firstSet, key) && firstSet[key] && secondSet[key]) out.push(key);
    }
    return out;
  }

  function tagsToText(list) {
    return (Array.isArray(list) ? list : []).join(", ");
  }

  function getCardHandle(card) {
    return (card && card.getAttribute && card.getAttribute("data-product-handle")) || "";
  }

  function getCardVariantId(card) {
    return normalizeVariantId((card && card.getAttribute && card.getAttribute("data-variant-id")) || "");
  }

  function getCardKey(card) {
    var handle = getCardHandle(card) || "(no-handle)";
    var variantId = getCardVariantId(card) || "no-variant";
    return handle + "::" + variantId;
  }

  function isPriorityOrderValid(orderRows) {
    var seenStandard = false;
    for (var i = 0; i < orderRows.length; i += 1) {
      if (orderRows[i].type === "standard") seenStandard = true;
      if (orderRows[i].type === "priority" && seenStandard) return false;
    }
    return true;
  }

  function readNumberFromText(text, allowedSizeSet) {
    var matches = String(text || "").match(/\d+/g);
    if (!matches) return 0;
    for (var i = 0; i < matches.length; i += 1) {
      var size = parseInt(matches[i], 10);
      if (allowedSizeSet[size]) return size;
    }
    return 0;
  }

  function readSizeFromRichText(text, allowedSizeSet) {
    var source = String(text || "");
    if (!source) return 0;

    var direct = readNumberFromText(source, allowedSizeSet);
    if (direct) return direct;

    var byWeekday = source.match(/(\d+)\s*meals?\s*each\s*week\s*day/i);
    if (byWeekday && byWeekday[1]) {
      var weekdaySize = parseInt(byWeekday[1], 10) * 5;
      if (allowedSizeSet[weekdaySize]) return weekdaySize;
    }

    var selectedOutOf = source.match(/(\d+)\s*(?:\/|of)\s*(\d+)\s*meals?/i);
    if (selectedOutOf && selectedOutOf[2]) {
      var outOfSize = parseInt(selectedOutOf[2], 10);
      if (allowedSizeSet[outOfSize]) return outOfSize;
    }

    var mealBox = source.match(/(\d+)\s*meal(?:s)?\s*(?:box|bundle|plan)/i);
    if (mealBox && mealBox[1]) {
      var mealBoxSize = parseInt(mealBox[1], 10);
      if (allowedSizeSet[mealBoxSize]) return mealBoxSize;
    }

    return 0;
  }

  function readNumberFromElement(el, allowedSizeSet) {
    if (!el) return 0;

    var dataCandidates = [
      el.getAttribute("data-loop-bundle-size"),
      el.getAttribute("data-bundle-size"),
      el.getAttribute("data-size"),
      el.getAttribute("data-meals")
    ];

    for (var i = 0; i < dataCandidates.length; i += 1) {
      var parsed = parseInt(dataCandidates[i], 10);
      if (allowedSizeSet[parsed]) return parsed;
    }

    return readNumberFromText(el.textContent || el.getAttribute("aria-label") || "", allowedSizeSet);
  }

  function queryDom(config) {
    var root = document.querySelector(config.rootSelector);
    if (!root) return null;

    return {
      root: root,
      cards: toArray(root.querySelectorAll(config.cardSelector))
    };
  }

  function detectBundleSize(dom, config) {
    var candidates = [];

    if (config.sizeSelector) {
      candidates = candidates.concat(toArray(dom.root.querySelectorAll(config.sizeSelector)));
    }

    candidates = candidates.concat(
      toArray(dom.root.querySelectorAll("[aria-current='true'], .loop-btn-selected, [data-loop-bundle-size], [data-bundle-size], [data-size], [data-meals]"))
    );

    for (var i = 0; i < candidates.length; i += 1) {
      var size = readNumberFromElement(candidates[i], config.allowedSizeSet);
      if (size) return size;
    }

    if (config.defaultBundleSize && config.allowedSizeSet[config.defaultBundleSize]) {
      return config.defaultBundleSize;
    }

    var textCandidates = [
      ".loop-h1.loop-bundle-title",
      ".loop-bundle-title",
      ".loop-bundle-progress-text",
      ".loop-bundle-progress",
      ".loop-summary",
      ".loop-selected-count"
    ];

    for (var n = 0; n < textCandidates.length; n += 1) {
      var textNode = dom.root.querySelector(textCandidates[n]);
      if (!textNode) continue;
      var parsedFromText = readSizeFromRichText(
        textNode.textContent || textNode.getAttribute("aria-label") || "",
        config.allowedSizeSet
      );
      if (parsedFromText) return parsedFromText;
    }

    return 0;
  }

  function detectBundleIdFromUrl() {
    if (!window.location) return "";
    var path = String(window.location.pathname || "");
    var changeMatch = path.match(/\/(?:a|apps)\/loop_subscriptions\/bundle\/change\/([^/?#]+)/i);
    if (changeMatch && changeMatch[1]) return String(changeMatch[1]).toLowerCase();

    var pathMatch = path.match(/\/(?:a|apps)\/loop_subscriptions\/bundle\/([^/?#]+)/i);
    if (pathMatch && pathMatch[1]) return String(pathMatch[1]).toLowerCase();

    var query = String(window.location.search || "");
    var queryMatch = query.match(/[?&](?:bundle_id|bundleId|bundle)=([^&#]+)/i);
    if (queryMatch && queryMatch[1]) return decodeURIComponent(queryMatch[1]).toLowerCase();

    return "";
  }

  function detectBundleIdFromDom(dom, config) {
    if (!dom || !dom.root) return "";

    var fromRoot = [
      dom.root.getAttribute("data-loop-bundle-id"),
      dom.root.getAttribute("data-bundle-id"),
      dom.root.getAttribute("data-bundle")
    ];

    for (var i = 0; i < fromRoot.length; i += 1) {
      if (fromRoot[i]) return String(fromRoot[i]).toLowerCase();
    }

    if (config.bundleIdSelector) {
      var node = dom.root.querySelector(config.bundleIdSelector);
      if (node) {
        var fromNode = node.getAttribute("data-loop-bundle-id") || node.getAttribute("data-bundle-id") || node.getAttribute("data-bundle");
        if (fromNode) return String(fromNode).toLowerCase();
      }
    }

    return "";
  }

  function detectBundleId(dom, config) {
    var domId = detectBundleIdFromDom(dom, config);
    var urlId = detectBundleIdFromUrl();

    if (window.location && /\/(?:a|apps)\/loop_subscriptions\/bundle\/change\//i.test(window.location.pathname || "")) {
      return domId || urlId;
    }
    return domId || urlId;
  }

  function getApplyStampKey(bundleId, size) {
    return String(bundleId || "unknown") + "::" + String(size || 0);
  }

  function isBundleChangePath() {
    return !!(window.location && /\/(?:a|apps)\/loop_subscriptions\/bundle\/change\//i.test(window.location.pathname || ""));
  }

  function getFrequencyButtonNodes(root, config) {
    if (!config || !config.frequencyButtonSelector) return [];
    var source = root || document;
    var list = [];
    try {
      list = toArray(source.querySelectorAll(config.frequencyButtonSelector));
    } catch (_e) {
      return [];
    }
    var out = [];
    for (var i = 0; i < list.length; i += 1) {
      if (out.indexOf(list[i]) === -1) out.push(list[i]);
    }
    return out;
  }

  function getVisibleFrequencyButtons(buttons) {
    var list = Array.isArray(buttons) ? buttons : [];
    var out = [];
    for (var i = 0; i < list.length; i += 1) {
      if (isVisible(list[i])) out.push(list[i]);
    }
    return out;
  }

  function getFrequencyButtonContainer(button) {
    if (!button || !button.closest) return button && button.parentElement ? button.parentElement : null;
    return button.closest(".loop-bundle-widget-frequency-button-container") || button.parentElement || null;
  }

  function getFrequencyButtonsForContainer(container, config, preferVisible) {
    var buttons = getFrequencyButtonNodes(container, config);
    if (!preferVisible) return buttons;
    var visibleButtons = getVisibleFrequencyButtons(buttons);
    return visibleButtons.length ? visibleButtons : buttons;
  }

  function getFrequencyButtonGroups(root, config, includeHidden) {
    var buttons = includeHidden ? getFrequencyButtonNodes(root, config) : getVisibleFrequencyButtons(getFrequencyButtonNodes(root, config));
    var groups = [];
    for (var i = 0; i < buttons.length; i += 1) {
      var button = buttons[i];
      var container = getFrequencyButtonContainer(button);
      if (!container) continue;

      var group = null;
      for (var g = 0; g < groups.length; g += 1) {
        if (groups[g].container === container) {
          group = groups[g];
          break;
        }
      }
      if (!group) {
        group = {
          container: container,
          buttons: []
        };
        groups.push(group);
      }
      group.buttons.push(button);
    }
    return groups;
  }

  function getFrequencyGroupsSnapshot(groups, config) {
    var source = Array.isArray(groups) ? groups : [];
    var out = [];
    for (var i = 0; i < source.length; i += 1) {
      var buttons = source[i].buttons || [];
      var selected = getSelectedFrequencyButton(buttons, config);
      var options = [];
      for (var n = 0; n < buttons.length; n += 1) {
        options.push(normalizeFrequencyLabel(getFrequencyButtonText(buttons[n])));
      }
      out.push({
        group: i,
        selected: normalizeFrequencyLabel(getFrequencyButtonText(selected)),
        options: options
      });
    }
    return out;
  }

  function freqDebug(eventName, meta) {
    try {
      var bucket = window.__LOOP_FREQ_DEBUG__ || [];
      var entry = {
        ts: Date.now(),
        event: String(eventName || ""),
        meta: meta || {}
      };
      bucket.push(entry);
      if (bucket.length > 120) bucket.shift();
      window.__LOOP_FREQ_DEBUG__ = bucket;
      window.__LOOP_FREQ_DEBUG_LAST__ = entry;
      if (window.__LOOP_FREQ_DEBUG_CONSOLE__ === true) {
        console.log("[loop-freq]", eventName, meta || {});
      }
    } catch (_e) {}
  }

  function getFrequencyButtonText(button) {
    if (!button) return "";
    var attrs = [
      "data-frequency-label",
      "data-loop-frequency-label",
      "data-selling-plan-name",
      "aria-label"
    ];
    for (var i = 0; i < attrs.length; i += 1) {
      var attrValue = button.getAttribute && button.getAttribute(attrs[i]);
      if (attrValue) return String(attrValue).replace(/\s+/g, " ").trim();
    }
    return String(button.textContent || "").replace(/\s+/g, " ").trim();
  }

  function normalizeFrequencyLabel(value) {
    return String(value || "")
      .toLowerCase()
      .replace(/\s+/g, " ")
      .trim();
  }

  function getFrequencyButtonIndex(buttons, button) {
    if (!button) return -1;
    for (var i = 0; i < buttons.length; i += 1) {
      if (buttons[i] === button) return i;
    }
    return -1;
  }

  function isFrequencyButtonSelected(button, config) {
    if (!button) return false;
    if (button.getAttribute("aria-current") === "true") return true;
    if (button.getAttribute("aria-pressed") === "true") return true;
    if (config && config.frequencySelectedClass && button.classList && button.classList.contains(config.frequencySelectedClass)) return true;
    return false;
  }

  function getSelectedFrequencyButton(buttons, config) {
    for (var i = 0; i < buttons.length; i += 1) {
      if (isFrequencyButtonSelected(buttons[i], config)) return buttons[i];
    }
    return null;
  }

  function getStorageAreas() {
    var out = [];
    try {
      if (window.localStorage) out.push(window.localStorage);
    } catch (_e) {}
    try {
      if (window.sessionStorage) out.push(window.sessionStorage);
    } catch (_e2) {}
    return out;
  }

  function readJsonFromStorage(key) {
    var storages = getStorageAreas();
    for (var i = 0; i < storages.length; i += 1) {
      try {
        var raw = storages[i].getItem(key);
        if (!raw) continue;
        var parsed = JSON.parse(raw);
        if (parsed && typeof parsed === "object") return parsed;
      } catch (_e) {}
    }
    return null;
  }

  function writeJsonToStorage(key, value) {
    var storages = getStorageAreas();
    var payload = "";
    try {
      payload = JSON.stringify(value || {});
    } catch (_e) {
      return false;
    }
    var wrote = false;
    for (var i = 0; i < storages.length; i += 1) {
      try {
        storages[i].setItem(key, payload);
        wrote = true;
      } catch (_e2) {}
    }
    return wrote;
  }

  function getFrequencyStoragePrefix(config) {
    return String((config && config.frequencyStorageKeyPrefix) || DEFAULT_CONFIG.frequencyStorageKeyPrefix || "loop:autoaddons:frequency");
  }

  function getFrequencyBundleStorageKey(bundleId, config) {
    return getFrequencyStoragePrefix(config) + ":bundle:" + String(bundleId || "unknown").toLowerCase();
  }

  function getFrequencyLastStorageKey(config) {
    return getFrequencyStoragePrefix(config) + ":last";
  }

  function resolveFrequencyBundleId(dom, config) {
    return detectBundleId(dom, config) || detectBundleIdFromUrl() || "";
  }

  function sanitizeFrequencyPreference(raw) {
    if (!raw || typeof raw !== "object") return null;
    var index = parseInt(raw.index, 10);
    var savedAt = parseInt(raw.savedAt, 10);
    return {
      bundleId: String(raw.bundleId || "").toLowerCase(),
      label: normalizeFrequencyLabel(raw.label || raw.text || ""),
      index: isNaN(index) ? -1 : index,
      savedAt: isNaN(savedAt) ? 0 : savedAt
    };
  }

  function readFrequencyPreference(bundleId, config) {
    var normalizedBundleId = String(bundleId || "").toLowerCase();
    var preference = null;

    if (normalizedBundleId) {
      preference = sanitizeFrequencyPreference(readJsonFromStorage(getFrequencyBundleStorageKey(normalizedBundleId, config)));
    }
    if (!preference && (!normalizedBundleId || isBundleChangePath())) {
      preference = sanitizeFrequencyPreference(readJsonFromStorage(getFrequencyLastStorageKey(config)));
    }
    if (!preference) return null;

    if (normalizedBundleId && preference.bundleId && preference.bundleId !== normalizedBundleId && !isBundleChangePath()) {
      return null;
    }
    return preference;
  }

  function saveFrequencyPreference(button, config, domHint) {
    var dom = domHint || queryDom(config);
    var root = (dom && dom.root) || document;
    var buttons = getFrequencyButtonNodes(root, config);
    if (!buttons.length && root !== document) {
      buttons = getFrequencyButtonNodes(document, config);
      root = document;
    }
    if (!buttons.length) return false;
    var groups = getFrequencyButtonGroups(root, config);
    var bundleId = resolveFrequencyBundleId(dom, config);
    if (!button && readFrequencyPreference(bundleId, config)) return false;

    var target = button;
    var indexSource = buttons;
    if (!target) {
      for (var g = 0; g < groups.length; g += 1) {
        var selectedInGroup = getSelectedFrequencyButton(groups[g].buttons, config);
        if (selectedInGroup) {
          target = selectedInGroup;
          indexSource = groups[g].buttons;
          break;
        }
      }
      if (!target) {
        target = getSelectedFrequencyButton(buttons, config);
      }
    } else {
      var targetContainerButtons = getFrequencyButtonsForContainer(getFrequencyButtonContainer(target), config, false);
      if (targetContainerButtons.length) {
        indexSource = targetContainerButtons;
      }
      if (getFrequencyButtonIndex(buttons, target) < 0) {
        var docButtons = getFrequencyButtonNodes(document, config);
        if (getFrequencyButtonIndex(docButtons, target) > -1) {
          buttons = docButtons;
          root = document;
          groups = getFrequencyButtonGroups(root, config);
        }
      }
    }
    if (!target) return false;

    var label = normalizeFrequencyLabel(getFrequencyButtonText(target));
    var index = getFrequencyButtonIndex(indexSource, target);
    if (index < 0) {
      index = getFrequencyButtonIndex(buttons, target);
    }
    if (index < 0 && !label) {
      freqDebug("save-skip:no-index", {
        bundleId: bundleId || "",
        hasTarget: true
      });
      return false;
    }

    var preference = {
      bundleId: String(bundleId || "").toLowerCase(),
      label: label,
      index: index,
      savedAt: Date.now()
    };

    if (bundleId) {
      writeJsonToStorage(getFrequencyBundleStorageKey(bundleId, config), preference);
    }
    writeJsonToStorage(getFrequencyLastStorageKey(config), preference);

    log(config, "Frequency saved", {
      bundleId: bundleId || "(unknown)",
      label: preference.label || "(empty)",
      index: preference.index
    });
    freqDebug("save", {
      bundleId: bundleId || "",
      label: preference.label,
      index: preference.index,
      groups: getFrequencyGroupsSnapshot(groups, config)
    });
    return true;
  }

  function findFrequencyButtonByPreference(buttons, preference) {
    if (!preference) return null;
    if (preference.label) {
      for (var i = 0; i < buttons.length; i += 1) {
        if (normalizeFrequencyLabel(getFrequencyButtonText(buttons[i])) === preference.label) {
          return buttons[i];
        }
      }
    }
    if (preference.index > -1 && preference.index < buttons.length) {
      return buttons[preference.index];
    }
    return null;
  }

  function restoreFrequencySelection(reason, config) {
    if (state.frequencyRestoreInFlight) return false;

    var dom = queryDom(config);
    var root = (dom && dom.root) || document;
    var groups = getFrequencyButtonGroups(root, config);
    if (!groups.length && root !== document) {
      groups = getFrequencyButtonGroups(document, config);
      root = document;
    }
    if (!groups.length) {
      var hiddenGroups = root === document ? [] : getFrequencyButtonGroups(root, config, true);
      if (!hiddenGroups.length) {
        hiddenGroups = getFrequencyButtonGroups(document, config, true);
      }
      if (hiddenGroups.length) {
        groups = hiddenGroups;
        freqDebug("restore-hidden-groups-fallback", {
          reason: reason || "",
          groups: getFrequencyGroupsSnapshot(groups, config)
        });
      }
    }
    if (!groups.length) {
      var inRootCount = root === document ? 0 : getFrequencyButtonNodes(root, config).length;
      var inDocCount = getFrequencyButtonNodes(document, config).length;
      freqDebug("restore-skip:no-visible-groups", { reason: reason || "", inRootCount: inRootCount, inDocCount: inDocCount });
      return false;
    }

    var bundleId = resolveFrequencyBundleId(dom, config);
    var preference = readFrequencyPreference(bundleId, config);
    if (!preference) {
      freqDebug("restore-skip:no-preference", { reason: reason || "", bundleId: bundleId || "" });
      saveFrequencyPreference(null, config, dom);
      return false;
    }

    var toClick = [];
    var affectedGroups = [];
    for (var g = 0; g < groups.length; g += 1) {
      var groupButtons = groups[g].buttons || [];
      if (!groupButtons.length) continue;

      var selected = getSelectedFrequencyButton(groupButtons, config);
      var selectedLabel = normalizeFrequencyLabel(getFrequencyButtonText(selected));
      var selectedIndex = getFrequencyButtonIndex(groupButtons, selected);
      var matchesSelected =
        selected &&
        ((preference.label && selectedLabel === preference.label) ||
          (!preference.label && preference.index > -1 && selectedIndex === preference.index));
      if (matchesSelected) continue;

      var target = findFrequencyButtonByPreference(groupButtons, preference);
      if (!target || target === selected) continue;
      toClick.push(target);
      affectedGroups.push(g);
    }

    if (!toClick.length) {
      freqDebug("restore-skip:already-matched", {
        reason: reason || "",
        bundleId: bundleId || "",
        preference: preference,
        groups: getFrequencyGroupsSnapshot(groups, config)
      });
      return false;
    }

    var token =
      String(bundleId || "unknown") +
      "::" +
      String(preference.label || "") +
      "::" +
      String(toClick.length) +
      "::" +
      String(affectedGroups.join(","));
    var now = Date.now();
    if (state.frequencyLastAppliedToken === token && now - state.frequencyLastAppliedAt < 1400) {
      return false;
    }

    state.frequencyRestoreInFlight = true;
    state.frequencyLastAppliedToken = token;
    state.frequencyLastAppliedAt = now;

    for (var i = 0; i < toClick.length; i += 1) {
      (function (targetButton, waitMs) {
        setTimeout(function () {
          if (!targetButton || targetButton.isConnected === false) return;
          triggerClick(targetButton);
        }, waitMs);
      })(toClick[i], i * Math.max(36, config.clickDelayMs));
    }

    setTimeout(function () {
      state.frequencyRestoreInFlight = false;
    }, Math.max(320, config.clickDelayMs + 180 + toClick.length * Math.max(36, config.clickDelayMs)));

    log(config, "Frequency restored", {
      reason: reason || "unknown",
      bundleId: bundleId || "(unknown)",
      label: preference.label || "(empty)"
    });
    freqDebug("restore-apply", {
      reason: reason || "",
      bundleId: bundleId || "",
      preference: preference,
      targetCount: toClick.length,
      affectedGroups: affectedGroups,
      groups: getFrequencyGroupsSnapshot(groups, config)
    });
    return true;
  }

  function scheduleFrequencyRestore(reason, config, delayMs) {
    clearTimeout(state.frequencyRestoreTimer);
    var waitMs = typeof delayMs === "number" ? delayMs : config.frequencyRestoreDelayMs;
    state.frequencyRestoreTimer = setTimeout(function () {
      runFrequencySafe(function () {
        return restoreFrequencySelection(reason, config);
      });
    }, waitMs);
  }

  function clearFrequencyRestoreBurst() {
    var timers = Array.isArray(state.frequencyBurstTimers) ? state.frequencyBurstTimers : [];
    for (var i = 0; i < timers.length; i += 1) {
      clearTimeout(timers[i]);
    }
    state.frequencyBurstTimers = [];
  }

  function scheduleFrequencyRestoreBurst(reason, config, delayList) {
    clearFrequencyRestoreBurst();
    var defaults = [80, 220, 500, 900, 1500, 2300];
    var list = Array.isArray(delayList) && delayList.length ? delayList : defaults;
    for (var i = 0; i < list.length; i += 1) {
      var wait = parseInt(list[i], 10);
      if (isNaN(wait) || wait < 0) wait = 0;
      state.frequencyBurstTimers.push(
        setTimeout(function () {
          runFrequencySafe(function () {
            return restoreFrequencySelection(reason, config);
          });
        }, wait)
      );
    }
  }

  function getCardWrap(card, config) {
    return card.closest(config.cardWrapSelector) || card;
  }

  function isVisible(el) {
    if (!el) return false;
    if (el.hasAttribute("hidden") || el.getAttribute("aria-hidden") === "true") return false;
    var style = window.getComputedStyle(el);
    if (style.display === "none" || style.visibility === "hidden") return false;
    return !!(el.getClientRects && el.getClientRects().length);
  }

  function getCardQty(card, config) {
    var input = card.querySelector(config.quantityInputSelector);
    if (!input) return 0;
    var value = parseInt(String(input.value || "").replace(/[^\d]/g, ""), 10);
    return isNaN(value) ? 0 : value;
  }

  function getCurrentBundleQty(dom, config) {
    var total = 0;
    for (var i = 0; i < dom.cards.length; i += 1) {
      total += getCardQty(dom.cards[i], config);
    }
    return total;
  }

  function isStandardSweetCard(card, config) {
    var variantId = getCardVariantId(card);
    return !!(variantId && config.sweetsVariantIdSet[variantId]);
  }

  function isAutoSelectSweetCard(card, config) {
    var variantId = getCardVariantId(card);
    return !!(variantId && config.sweetsAutoSelectVariantIdSet && config.sweetsAutoSelectVariantIdSet[variantId]);
  }

  function isFreeSweetCard(card, config) {
    var variantId = getCardVariantId(card);
    return !!(variantId && config.sweetsFreeVariantId && variantId === config.sweetsFreeVariantId);
  }

  function isAlwaysHiddenCard(card, config) {
    var variantId = getCardVariantId(card);
    return !!(variantId && config.alwaysHiddenVariantIdSet && config.alwaysHiddenVariantIdSet[variantId]);
  }

  function collectSweetCards(dom, config) {
    var standardCards = [];
    var freeCard = null;
    for (var i = 0; i < dom.cards.length; i += 1) {
      var card = dom.cards[i];
      if (isAlwaysHiddenCard(card, config)) continue;
      if (isFreeSweetCard(card, config)) {
        freeCard = card;
      } else if (isAutoSelectSweetCard(card, config)) {
        standardCards.push(card);
      }
    }
    var allSweetCards = standardCards.slice();
    if (freeCard) allSweetCards.push(freeCard);
    return {
      standardCards: standardCards,
      freeCard: freeCard,
      allSweetCards: allSweetCards
    };
  }

  function collectCardVariantIds(dom) {
    var out = [];
    var seen = {};
    if (!dom || !dom.cards) return out;
    for (var i = 0; i < dom.cards.length; i += 1) {
      var id = getCardVariantId(dom.cards[i]);
      if (!id || seen[id]) continue;
      seen[id] = true;
      out.push(id);
    }
    return out;
  }

  function setCardVisible(card, config, visible, instant) {
    var wrap = getCardWrap(card, config);
    if (!wrap) return;

    if (wrap.__loopHideTimer) {
      clearTimeout(wrap.__loopHideTimer);
      wrap.__loopHideTimer = null;
    }

    var shouldAnimate = !instant;
    var isHidden = wrap.classList.contains("loop-autoaddons-hidden");
    var isExiting = wrap.classList.contains("loop-autoaddons-exit");

    if (visible) {
      if (!isHidden && !isExiting) return;
    } else if (shouldAnimate) {
      if (isHidden || isExiting) return;
    } else if (isHidden) {
      return;
    }

    if (!shouldAnimate) {
      wrap.classList.remove("loop-autoaddons-exit");
      if (visible) {
        wrap.classList.remove("loop-autoaddons-hidden");
      } else {
        wrap.classList.add("loop-autoaddons-hidden");
      }
      return;
    }

    wrap.classList.add("loop-autoaddons-anim");
    if (visible) {
      wrap.classList.remove("loop-autoaddons-hidden");
      requestAnimationFrame(function () {
        wrap.classList.remove("loop-autoaddons-exit");
      });
    } else {
      wrap.classList.add("loop-autoaddons-exit");
      wrap.__loopHideTimer = setTimeout(function () {
        wrap.classList.add("loop-autoaddons-hidden");
      }, 300);
    }
  }

  function applyDefaultCardVisibility(dom, config) {
    if (!dom || !dom.cards || state.sweetStepShown) return;
    ensureSweetStyles(config);
    state.visibilityApplying = true;
    try {
      dom.root.classList.remove("loop-autoaddons-sweet-step-active");
      var gridNodes = toArray(dom.root.querySelectorAll(".loop-autoaddons-sweets-grid-2col"));
      for (var g = 0; g < gridNodes.length; g += 1) {
        gridNodes[g].classList.remove("loop-autoaddons-sweets-grid-2col");
      }
      for (var i = 0; i < dom.cards.length; i += 1) {
        var card = dom.cards[i];
        var shouldHide = false;

        if (isAlwaysHiddenCard(card, config)) {
          shouldHide = true;
        } else if (config.hideSweetsUntilStep && (isStandardSweetCard(card, config) || isFreeSweetCard(card, config))) {
          shouldHide = true;
        }
        setCardVisible(card, config, !shouldHide, true);
      }

      var header = dom.root.querySelector(".loop-autoaddons-sweets-header");
      if (header && header.parentNode) {
        header.parentNode.removeChild(header);
      }
    } finally {
      state.visibilityApplying = false;
    }
  }

  function scheduleDefaultVisibility(config, delayMs) {
    if (state.sweetStepShown) return;
    clearTimeout(state.defaultVisibilityTimer);
    state.defaultVisibilityTimer = setTimeout(function () {
      var dom = queryDom(config);
      if (!dom) return;
      applyDefaultCardVisibility(dom, config);
    }, typeof delayMs === "number" ? delayMs : 80);
  }

  function ensureSweetStyles(config) {
    if (document.getElementById("loop-autoaddons-sweets-style")) return;
    var mobileMaxWidth =
      (config && parseInt(config.mobileBreakpointPx, 10)) || parseInt(DEFAULT_CONFIG.mobileBreakpointPx, 10) || 991;
    var style = document.createElement("style");
    style.id = "loop-autoaddons-sweets-style";
    style.textContent =
      ".loop-autoaddons-hidden{display:none !important;}" +
      ".loop-autoaddons-anim{transition:opacity .32s ease,transform .32s ease;will-change:opacity,transform;}" +
      ".loop-autoaddons-exit{opacity:0;transform:translateY(6px);pointer-events:none;}" +
      ".loop-autoaddons-sweets-anchor{display:block;height:0;line-height:0;pointer-events:none;}" +
      ".loop-autoaddons-sweets-header{margin:10px 0 20px;padding:18px 16px;border:1px solid #e8e8e8;border-radius:14px;background:linear-gradient(180deg,#fff 0%,#fafafa 100%);box-shadow:0 8px 20px rgba(17,17,17,.06);opacity:0;transform:translateY(8px);transition:opacity .28s ease,transform .28s ease;}" +
      ".loop-autoaddons-sweets-header.loop-autoaddons-sweets-header-ready{opacity:1;transform:translateY(0);}" +
      ".loop-autoaddons-sweets-title{margin:0 0 8px;font-size:22px;font-weight:700;line-height:1.2;color:#121212;}" +
      ".loop-autoaddons-sweets-subtitle{margin:0 0 12px;font-size:14px;line-height:1.35;color:#4a4a4a;}" +
      ".loop-autoaddons-sweets-progress{position:relative;height:10px;background:#ececec;border-radius:999px;overflow:hidden;}" +
      ".loop-autoaddons-sweets-progress-fill{height:100%;width:0;background:linear-gradient(90deg,#111 0%,#3a3a3a 100%);transition:width .2s ease;}" +
      ".loop-autoaddons-sweets-progress-text{margin:10px 0 0;font-size:13px;font-weight:600;color:#222;}" +
      ".loop-autoaddons-free-badge{display:inline-flex;align-items:center;gap:6px;margin:0 0 8px;padding:4px 10px;border-radius:999px;background:#111;color:#fff;font-size:11px;font-weight:700;letter-spacing:.02em;text-transform:uppercase;}" +
      ".loop-autoaddons-treat-price{margin:8px 0 0;font-size:13px;line-height:1.25;color:#3a3a3a;font-weight:600;text-align:center;}" +
      ".loop-autoaddons-checkout-wrap{display:flex;justify-content:center;align-items:center;width:100%;}" +
      ".loop-autoaddons-checkout-btn{position:relative !important;width:100% !important;max-width:450px !important;overflow:hidden;}" +
      ".loop-autoaddons-checkout-btn .loop-bundle-cart-btn-text-container{justify-content:center !important;}" +
      ".loop-autoaddons-checkout-btn[aria-busy='true']{pointer-events:none;}" +
      ".loop-autoaddons-checkout-btn[aria-busy='true'] .loop-bundle-cart-btn-text-container{opacity:.32;transition:opacity .18s ease;}" +
      ".loop-autoaddons-checkout-btn[aria-busy='true']::after{content:'';position:absolute;top:50%;left:50%;width:18px;height:18px;margin:-9px 0 0 -9px;border:2px solid currentColor;border-right-color:transparent;border-radius:999px;animation:loop-autoaddons-spin .72s linear infinite;}" +
      ".loop-autoaddons-source-cta-hidden{position:absolute !important;left:-99999px !important;top:auto !important;width:1px !important;height:1px !important;overflow:hidden !important;opacity:0 !important;pointer-events:none !important;}" +
      "@keyframes loop-autoaddons-spin{to{transform:rotate(360deg);}}" +
      "@media (max-width:" +
      mobileMaxWidth +
      "px){" +
      ".loop-bs-container.loop-autoaddons-sweet-step-active .loop-autoaddons-sweets-grid-2col{display:grid !important;grid-template-columns:repeat(2,minmax(0,1fr)) !important;gap:16px 0 !important;align-items:stretch !important;}" +
      ".loop-bs-container.loop-autoaddons-sweet-step-active .loop-autoaddons-sweets-grid-2col .loop-bundle-product-wrapper{grid-column:auto !important;width:auto !important;max-width:none !important;min-width:0 !important;margin:0 !important;}" +
      ".loop-bs-container.loop-autoaddons-sweet-step-active .loop-autoaddons-treat-price{margin-top:0 !important;font-size:12px;}" +
      "}";
    document.head.appendChild(style);
  }

  function getSweetStepCheckoutButton() {
    var wraps = toArray(document.querySelectorAll(".loop-bundle-view-cart-btn"));
    var fallback = null;
    for (var i = 0; i < wraps.length; i += 1) {
      var wrap = wraps[i];
      var button = wrap.querySelector("button.loop-btn-add-to-cart, button.loop-btn");
      if (!button) continue;
      var candidate = {
        wrap: wrap,
        button: button
      };
      if (!fallback) fallback = candidate;
      if (isVisible(button) || isVisible(wrap)) return candidate;
    }
    return fallback;
  }

  function getSweetStepSourceButton(config) {
    var selector = (config && config.sweetsStepTriggerSelector) || DEFAULT_CONFIG.sweetsStepTriggerSelector;
    var buttons = toArray(document.querySelectorAll(selector));
    var fallback = null;
    for (var i = 0; i < buttons.length; i += 1) {
      var button = buttons[i];
      var candidate = {
        wrap: button.parentElement || null,
        button: button
      };
      if (!fallback) fallback = candidate;
      if (isVisible(button) || (candidate.wrap && isVisible(candidate.wrap))) return candidate;
    }
    return fallback;
  }

  function setSweetSourceCtaHidden(source, hidden) {
    if (!source || !source.wrap || source.wrap === source.button) return;
    if (hidden) {
      source.wrap.classList.add("loop-autoaddons-source-cta-hidden");
      source.wrap.setAttribute("aria-hidden", "true");
    } else {
      source.wrap.classList.remove("loop-autoaddons-source-cta-hidden");
      source.wrap.removeAttribute("aria-hidden");
    }
  }

  function syncSweetStepCheckoutCta(config) {
    if (!state.sweetStepShown) return false;
    var checkout = getSweetStepCheckoutButton();
    var source = getSweetStepSourceButton(config);
    if (!source || !source.button) return false;
    if (!checkout || !checkout.button || checkout.button.isConnected === false || checkout.wrap.isConnected === false) {
      setSweetSourceCtaHidden(source, false);
      return false;
    }

    var checkoutVisible = isVisible(checkout.button) || isVisible(checkout.wrap);
    if (!checkoutVisible) {
      setSweetSourceCtaHidden(source, false);
      return false;
    }

    checkout.wrap.classList.add("loop-autoaddons-checkout-wrap");
    checkout.wrap.classList.add("flex", "justify-center", "items-center");
    checkout.wrap.classList.remove("loop-autoaddons-hidden", "loop-autoaddons-exit");
    setSweetSourceCtaHidden(source, !!(source.wrap && source.wrap !== checkout.wrap));

    if (checkout.button.getAttribute("data-loop-autoaddons-checkout") !== "true") {
      checkout.button.setAttribute("data-loop-autoaddons-checkout", "true");
      checkout.button.setAttribute("data-loop-autoaddons-original-class", checkout.button.className || "");
    }

    checkout.button.className = mergeClassNames(
      checkout.button.getAttribute("data-loop-autoaddons-original-class") || "",
      source.button.className || "",
      "loop-autoaddons-checkout-btn"
    );
    checkout.button.setAttribute("type", source.button.getAttribute("type") || checkout.button.getAttribute("type") || "button");
    if (!checkout.button.querySelector(".loop-bundle-add-to-cart-text") && source.button.innerHTML) {
      checkout.button.innerHTML = source.button.innerHTML;
    }

    var textNode = checkout.button.querySelector(".loop-bundle-add-to-cart-text");
    if (textNode) {
      textNode.textContent = "";
    }

    checkout.button.setAttribute("aria-label", "Activate My Plan");
    if (source.button.getAttribute("aria-disabled") === "true" || source.button.disabled) {
      checkout.button.setAttribute("aria-disabled", "true");
    } else {
      checkout.button.removeAttribute("aria-disabled");
    }
    checkout.button.disabled = !!source.button.disabled || Date.now() < state.sweetCheckoutProxyBusyUntil;
    if (Date.now() < state.sweetCheckoutProxyBusyUntil) {
      checkout.button.setAttribute("aria-busy", "true");
    } else {
      checkout.button.removeAttribute("aria-busy");
    }
    return true;
  }

  function tryHandleSweetStepCheckoutTrigger(event, config) {
    if (!state.sweetStepShown || !event || !event.target || !event.target.closest) return false;
    var button = event.target.closest(".loop-bundle-view-cart-btn button.loop-btn-add-to-cart, .loop-bundle-view-cart-btn button.loop-btn");
    if (!button) return false;
    var source = getSweetStepSourceButton(config);
    if (!source || !source.button || source.button.isConnected === false) return false;
    var busyMs = Math.max(400, parseInt((config && config.sweetCheckoutBusyMs) || DEFAULT_CONFIG.sweetCheckoutBusyMs, 10) || 0);
    if (Date.now() < state.sweetCheckoutProxyBusyUntil) {
      suppressEvent(event, "sweet-step-checkout-busy");
      return true;
    }

    suppressEvent(event, "sweet-step-checkout");
    state.sweetCheckoutProxyBusyUntil = Date.now() + busyMs;
    button.disabled = true;
    button.setAttribute("aria-busy", "true");
    setTimeout(function () {
      if (!button || button.isConnected === false) return;
      button.disabled = false;
      button.removeAttribute("aria-busy");
    }, busyMs);
    runFrequencySafe(function () {
      scheduleFrequencyRestoreBurst("sweet-step-primary-cta", config, [0, 120, 320]);
      return true;
    });
    freqDebug("checkout-trigger", {
      mode: "proxy-source-button"
    });
    triggerClick(source.button);
    return true;
  }

  function createSweetHeader(config) {
    var header = document.createElement("div");
    header.className = "loop-autoaddons-sweets-header";

    var title = document.createElement("h3");
    title.className = "loop-autoaddons-sweets-title";
    title.textContent = config.sweetsTitle;

    var subtitle = document.createElement("p");
    subtitle.className = "loop-autoaddons-sweets-subtitle";
    subtitle.textContent = config.sweetsSubtitle;

    var progress = document.createElement("div");
    progress.className = "loop-autoaddons-sweets-progress";
    var progressFill = document.createElement("div");
    progressFill.className = "loop-autoaddons-sweets-progress-fill";
    progress.appendChild(progressFill);

    var progressText = document.createElement("p");
    progressText.className = "loop-autoaddons-sweets-progress-text";

    header.appendChild(title);
    header.appendChild(subtitle);
    header.appendChild(progress);
    header.appendChild(progressText);
    return header;
  }

  function getOrCreateSweetScrollAnchor(root) {
    if (!root) return null;
    var anchor = root.querySelector(".loop-autoaddons-sweets-anchor");
    if (anchor) return anchor;

    anchor = document.createElement("div");
    anchor.className = "loop-autoaddons-sweets-anchor";
    return anchor;
  }

  function detectCardsContainer(dom, config) {
    if (!dom || !dom.cards || !dom.cards.length) return null;
    var firstWrap = getCardWrap(dom.cards[0], config);
    if (!firstWrap) return null;

    var current = firstWrap.parentElement;
    while (current && current !== dom.root) {
      var cardWrapCount = current.querySelectorAll(config.cardWrapSelector).length;
      if (cardWrapCount >= Math.min(3, dom.cards.length)) return current;
      current = current.parentElement;
    }
    return firstWrap.parentElement || null;
  }

  function detectProductsGridContainer(dom) {
    if (!dom || !dom.root) return null;
    var selectors = [
      ".loop-products-align-new.loop-goal-fallback-grid-container",
      ".loop-goal-fallback-grid-container",
      ".loop-products-align-new"
    ];
    for (var i = 0; i < selectors.length; i += 1) {
      var node = dom.root.querySelector(selectors[i]);
      if (!node) continue;
      if (node.querySelector(".loop-bundle-product-wrapper, .loop-bundle-product-card")) return node;
    }
    return null;
  }

  function ensureSweetCardsGridLayout(dom, config) {
    if (!dom || !dom.root) return;
    var existing = toArray(dom.root.querySelectorAll(".loop-autoaddons-sweets-grid-2col"));
    for (var i = 0; i < existing.length; i += 1) {
      existing[i].classList.remove("loop-autoaddons-sweets-grid-2col");
    }

    if (!isMobileViewport(config)) return;
    var cardsContainer = detectCardsContainer(dom, config) || detectProductsGridContainer(dom);
    if (!cardsContainer) return;
    cardsContainer.classList.add("loop-autoaddons-sweets-grid-2col");
  }

  function activateSweetHeader(header) {
    if (!header || header.__loopHeaderActivated) return;
    header.__loopHeaderActivated = true;
    requestAnimationFrame(function () {
      header.classList.add("loop-autoaddons-sweets-header-ready");
    });
  }

  function mountSweetHeader(dom, sweets, config) {
    var root = dom.root;
    var header = root.querySelector(".loop-autoaddons-sweets-header");
    if (!header) {
      header = createSweetHeader(config);
    }
    var scrollAnchor = getOrCreateSweetScrollAnchor(root);
    var gridContainer = detectProductsGridContainer(dom);
    var cardsContainer = detectCardsContainer(dom, config);
    var anchor = gridContainer || cardsContainer;
    if (anchor && anchor.parentNode) {
      if (header.parentNode !== anchor.parentNode || header.nextSibling !== anchor) {
        anchor.parentNode.insertBefore(header, anchor);
      }
      if (scrollAnchor && (scrollAnchor.parentNode !== header.parentNode || scrollAnchor.nextSibling !== header)) {
        header.parentNode.insertBefore(scrollAnchor, header);
      }
      activateSweetHeader(header);
      return header;
    }

    if (header.parentNode) {
      if (scrollAnchor && (scrollAnchor.parentNode !== header.parentNode || scrollAnchor.nextSibling !== header)) {
        header.parentNode.insertBefore(scrollAnchor, header);
      }
      activateSweetHeader(header);
      return header;
    }
    root.insertBefore(header, root.firstChild);
    if (scrollAnchor) root.insertBefore(scrollAnchor, header);
    activateSweetHeader(header);
    return header;
  }

  function smoothScrollToElement(el, offsetPx) {
    if (!el) return;
    var offset = typeof offsetPx === "number" ? offsetPx : 0;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        try {
          var rect = el.getBoundingClientRect();
          var targetTop = rect.top + (window.pageYOffset || document.documentElement.scrollTop || 0) - offset;
          window.scrollTo({
            top: targetTop > 0 ? targetTop : 0,
            behavior: "smooth"
          });
        } catch (_e) {
          try {
            el.scrollIntoView({ behavior: "smooth", block: "start" });
          } catch (_e2) {}
        }
      });
    });
  }

  function scrollToSweetHeader(config, delayMs) {
    setTimeout(function () {
      var dom = queryDom(config);
      if (!dom || !dom.root) return;
      var target =
        dom.root.querySelector(".loop-bundle-select-product-title-new-container") ||
        dom.root.querySelector(".loop-bundle-select-product-title-new") ||
        dom.root.querySelector(".loop-autoaddons-sweets-anchor") ||
        dom.root.querySelector(".loop-autoaddons-sweets-header");
      if (!target) return;
      if (target.classList && target.classList.contains("loop-bundle-select-product-title-new") && target.parentElement) {
        target = target.parentElement;
      }
      smoothScrollToElement(target, config.sweetsScrollOffsetPx);
    }, typeof delayMs === "number" ? delayMs : 0);
  }

  function isMobileViewport(config) {
    var width = 0;
    try {
      width = window.innerWidth || document.documentElement.clientWidth || 0;
    } catch (_e) {}
    return width > 0 && width <= config.mobileBreakpointPx;
  }

  function tryClickBottomSheetClose(config) {
    var closeBtn = document.querySelector(config.bottomSheetCloseSelector);
    if (!closeBtn) return false;
    triggerClick(closeBtn);
    return true;
  }

  function collapseBottomSheetFallback(config) {
    var container = document.querySelector(config.bottomSheetContainerSelector);
    if (!container) return false;
    container.classList.remove("expanded");
    container.style.pointerEvents = "none";
    container.style.transform = "translateY(100%)";
    container.setAttribute("aria-hidden", "true");
    return true;
  }

  function closeMobileBottomSheet(config) {
    if (!config.closeMobileBottomSheetOnSweetStep || !isMobileViewport(config)) return;
    var attempts = 0;
    var maxAttempts = 10;

    function attempt() {
      attempts += 1;
      if (tryClickBottomSheetClose(config)) return;
      if (attempts >= maxAttempts) {
        collapseBottomSheetFallback(config);
        return;
      }
      setTimeout(attempt, 70);
    }

    setTimeout(attempt, 0);
  }

  function updateSweetHeader(header, selectedCount, requiredCount) {
    if (!header) return;
    var fill = header.querySelector(".loop-autoaddons-sweets-progress-fill");
    var text = header.querySelector(".loop-autoaddons-sweets-progress-text");
    var progress = requiredCount > 0 ? Math.min(100, Math.round((selectedCount / requiredCount) * 100)) : 0;
    if (fill) fill.style.width = String(progress) + "%";
    if (text) {
      if (selectedCount >= requiredCount) {
        text.textContent = "Sweet bonus unlocked!";
      } else {
        text.textContent = String(selectedCount) + " / " + String(requiredCount) + " sweets selected";
      }
    }
  }

  function ensureFreeBadge(card, config) {
    if (!card) return;
    var wrap = getCardWrap(card, config);
    if (!wrap || wrap.querySelector(".loop-autoaddons-free-badge")) return;
    var badge = document.createElement("div");
    badge.className = "loop-autoaddons-free-badge";
    badge.textContent = "Free Treat";
    wrap.insertBefore(badge, wrap.firstChild);
  }

  function getSelectedSweetCount(standardCards, config) {
    var selected = 0;
    for (var i = 0; i < standardCards.length; i += 1) {
      if (getCardQty(standardCards[i], config) > 0) selected += 1;
    }
    return selected;
  }

  function getRequiredSweetCount(config, sweets) {
    var available = sweets && sweets.standardCards ? sweets.standardCards.length : 0;
    var required = parseInt(config.sweetsRequiredCount, 10) || 1;
    if (required < 1) required = 1;
    if (available > 0 && required > available) required = available;
    return required;
  }

  function getSweetBonusMarkerProperties() {
    return {
      _loopAutoaddonsSweetBonus: "1"
    };
  }

  function hasSweetBonusMarker(item) {
    var properties = (item && item.properties) || {};
    return String(properties._loopAutoaddonsSweetBonus || "") === "1";
  }

  function getCartItemVariantId(item) {
    if (!item) return "";
    return normalizeVariantId(item.variant_id || item.id || "");
  }

  async function fetchCartSnapshot() {
    try {
      var response = await fetch("/cart.js", {
        credentials: "same-origin",
        headers: {
          Accept: "application/json"
        }
      });
      if (!response.ok) return null;
      return await response.json();
    } catch (_e) {
      return null;
    }
  }

  function findCartItem(cart, variantId, markerOnly) {
    var target = normalizeVariantId(variantId);
    if (!target || !cart || !Array.isArray(cart.items)) return null;

    for (var i = 0; i < cart.items.length; i += 1) {
      var item = cart.items[i];
      if (getCartItemVariantId(item) !== target) continue;
      if (markerOnly && !hasSweetBonusMarker(item)) continue;
      return item;
    }
    return null;
  }

  async function addFreeSweetToCart(config) {
    var variantId = normalizeVariantId(config.sweetsFreeVariantId);
    if (!variantId) return false;

    var cart = await fetchCartSnapshot();
    if (cart && findCartItem(cart, variantId, false)) {
      trace("sweet-step: free sweet already in cart", { variantId: variantId });
      return false;
    }

    try {
      var response = await fetch("/cart/add.js", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          properties: getSweetBonusMarkerProperties()
        })
      });

      if (!response.ok) {
        trace("sweet-step: failed to add free sweet", { variantId: variantId, status: response.status });
        return false;
      }

      trace("sweet-step: free sweet added to cart", { variantId: variantId });
      return true;
    } catch (_e) {
      trace("sweet-step: exception while adding free sweet", { variantId: variantId });
      return false;
    }
  }

  async function removeFreeSweetFromCart(config) {
    var variantId = normalizeVariantId(config.sweetsFreeVariantId);
    if (!variantId) return false;

    var cart = await fetchCartSnapshot();
    var item = findCartItem(cart, variantId, true);
    if (!item) return false;

    var payload = item.key ? { id: item.key, quantity: 0 } : { id: variantId, quantity: 0 };

    try {
      var response = await fetch("/cart/change.js", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        trace("sweet-step: failed to remove free sweet", { variantId: variantId, status: response.status });
        return false;
      }

      trace("sweet-step: free sweet removed from cart", { variantId: variantId });
      return true;
    } catch (_e) {
      trace("sweet-step: exception while removing free sweet", { variantId: variantId });
      return false;
    }
  }

  function showOnlySweetCards(dom, sweets, config, showFreeCard, instant) {
    for (var i = 0; i < dom.cards.length; i += 1) {
      var card = dom.cards[i];
      var keep = !isAlwaysHiddenCard(card, config) && isAutoSelectSweetCard(card, config);
      setCardVisible(card, config, keep, instant === true);
    }
  }

  function ensureTreatPriceLabel(card, config) {
    if (!card) return;
    var wrap = getCardWrap(card, config);
    if (!wrap) return;
    var label = wrap.querySelector(".loop-autoaddons-treat-price");
    if (!label) {
      label = document.createElement("p");
      label.className = "loop-autoaddons-treat-price";
      wrap.appendChild(label);
    }
    label.textContent = config.sweetsTreatPriceText;
  }

  function ensureTreatPriceLabels(cards, config) {
    if (!cards || !cards.length) return;
    for (var i = 0; i < cards.length; i += 1) {
      ensureTreatPriceLabel(cards[i], config);
    }
  }

  function findSweetCardByVariantId(cards, variantId) {
    var target = normalizeVariantId(variantId);
    if (!target) return null;
    for (var i = 0; i < cards.length; i += 1) {
      if (getCardVariantId(cards[i]) === target) return cards[i];
    }
    return null;
  }

  async function autoSelectInitialSweets(config) {
    if (!state.sweetStepShown || state.sweetAutoSelectDone) return;
    state.sweetAutoSelectDone = true;

    var targetVariantIds = Array.isArray(config.sweetsAutoSelectVariantIds) ? config.sweetsAutoSelectVariantIds : [];
    if (!targetVariantIds.length) return;

    var dom = queryDom(config);
    if (!dom || !dom.cards.length) return;

    var sweets = collectSweetCards(dom, config);
    if (!sweets.standardCards.length) return;

    var added = [];
    for (var i = 0; i < targetVariantIds.length; i += 1) {
      var variantId = normalizeVariantId(targetVariantIds[i]);
      var card = findSweetCardByVariantId(sweets.standardCards, variantId);
      if (!card) continue;
      if (getCardQty(card, config) > 0) continue;

      var changed = await addCardOnce(card, config);
      if (changed > 0) added.push(variantId);
    }

    trace("sweet-step: auto-select complete", {
      targets: targetVariantIds,
      added: added
    });
    scheduleSweetSync(config, config.clickDelayMs + 80);
  }

  function scheduleSweetAutoSelect(config, delayMs) {
    if (!state.sweetStepShown || state.sweetAutoSelectDone) return;
    clearTimeout(state.sweetAutoSelectTimer);
    state.sweetAutoSelectTimer = setTimeout(function () {
      autoSelectInitialSweets(config);
    }, typeof delayMs === "number" ? delayMs : 120);
  }

  function enterSweetStep(config) {
    if (!config.sweetsStepEnabled) {
      trace("sweet-step: disabled");
      return false;
    }
    if (state.sweetStepShown) {
      trace("sweet-step: already shown");
      return false;
    }

    var dom = queryDom(config);
    if (!dom || !dom.cards.length) {
      trace("sweet-step: no dom/cards");
      return false;
    }

    var sweets = collectSweetCards(dom, config);
    if (!sweets.standardCards.length) {
      trace("sweet-step: no sweets matched", {
        configuredSweetVariantIds: config.sweetsVariantIds,
        configuredFreeVariantId: config.sweetsFreeVariantId,
        foundVariantIds: collectCardVariantIds(dom)
      });
      return false;
    }

    runFrequencySafe(function () {
      saveFrequencyPreference(null, config, dom);
      return true;
    });
    ensureSweetStyles(config);
    showOnlySweetCards(dom, sweets, config, false, false);
    dom.root.classList.add("loop-autoaddons-sweet-step-active");
    ensureSweetCardsGridLayout(dom, config);
    ensureTreatPriceLabels(sweets.standardCards, config);
    if (sweets.freeCard) {
      ensureFreeBadge(sweets.freeCard, config);
      setCardVisible(sweets.freeCard, config, false, false);
    }

    var header = mountSweetHeader(dom, sweets, config);
    updateSweetHeader(header, getSelectedSweetCount(sweets.standardCards, config), getRequiredSweetCount(config, sweets));

    state.sweetStepShown = true;
    state.sweetStepInterceptUntil = Date.now() + 1400;
    window.__LOOP_AUTOADDONS_SWEET_STEP_ACTIVE = true;
    trace("sweet-step: entered", {
      standardSweetCount: sweets.standardCards.length,
      freeSweetFound: !!sweets.freeCard
    });
    closeMobileBottomSheet(config);
    runFrequencySafe(function () {
      scheduleFrequencyRestoreBurst("sweet-step-enter", config, [80, 220, 500, 900, 1500, 2300]);
      return true;
    });
    syncSweetStepCheckoutCta(config);
    scheduleSweetSync(config, 80);
    scheduleSweetAutoSelect(config, config.clickDelayMs + 80);
    scrollToSweetHeader(config, 0);
    scrollToSweetHeader(config, config.sweetsScrollSettleDelayMs);
    scrollToSweetHeader(config, config.sweetsScrollFinalDelayMs);
    return true;
  }

  function suppressEvent(event, reason) {
    if (!event) return;
    trace("sweet-step: suppress event", { type: event.type, reason: reason });
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === "function") {
      event.stopImmediatePropagation();
    }
  }

  function tryInterceptSweetStepTrigger(event, config) {
    if (!config.sweetsStepEnabled || !event || !event.target || !event.target.closest) return false;
    if (event.isTrusted === false) return false;
    if (event.target.closest(".loop-bundle-view-cart-btn")) return false;
    var triggerBtn = event.target.closest(config.sweetsStepTriggerSelector);
    if (!triggerBtn) return false;

    if (state.sweetStepShown) {
      if (Date.now() <= state.sweetStepInterceptUntil) {
        suppressEvent(event, "post-enter guard");
        return true;
      }
      return false;
    }

    trace("sweet-step: trigger detected", {
      eventType: event.type,
      selector: config.sweetsStepTriggerSelector
    });
    runFrequencySafe(function () {
      saveFrequencyPreference(null, config);
      return true;
    });
    if (!enterSweetStep(config)) {
      trace("sweet-step: trigger detected, but enter failed", { eventType: event.type });
      return false;
    }
    suppressEvent(event, "entered");
    return true;
  }

  function scheduleSweetSync(config, delayMs) {
    if (!state.sweetStepShown) return;
    clearTimeout(state.sweetSyncTimer);
    state.sweetSyncTimer = setTimeout(function () {
      syncSweetStepState(config);
    }, typeof delayMs === "number" ? delayMs : 80);
  }

  async function syncSweetStepState(config) {
    if (!state.sweetStepShown || state.sweetSyncRunning) return;
    state.sweetSyncRunning = true;
    try {
      var dom = queryDom(config);
      if (!dom || !dom.cards.length) return;

      var sweets = collectSweetCards(dom, config);
      if (!sweets.standardCards.length) return;

      var selectedCount = getSelectedSweetCount(sweets.standardCards, config);
      var requiredCount = getRequiredSweetCount(config, sweets);
      var unlocked = selectedCount >= requiredCount;
      var bonusStateChanged = state.sweetBonusUnlocked !== unlocked;

      var header = mountSweetHeader(dom, sweets, config);
      updateSweetHeader(header, selectedCount, requiredCount);

      ensureSweetCardsGridLayout(dom, config);
      showOnlySweetCards(dom, sweets, config, unlocked, true);
      ensureTreatPriceLabels(sweets.standardCards, config);
      syncSweetStepCheckoutCta(config);

      if (state.sweetBonusApplying) return;

      state.sweetBonusApplying = true;
      try {
        if (unlocked && bonusStateChanged) {
          await addFreeSweetToCart(config);
        } else if (!unlocked && bonusStateChanged) {
          await removeFreeSweetFromCart(config);
        }
      } finally {
        state.sweetBonusUnlocked = unlocked;
        state.sweetBonusApplying = false;
      }
    } finally {
      state.sweetSyncRunning = false;
    }
  }

  function isButtonEnabled(button) {
    if (!button) return false;
    if (button.disabled) return false;
    if (button.getAttribute("aria-disabled") === "true") return false;
    if (button.classList.contains("disabled") || button.classList.contains("is-disabled")) return false;
    return true;
  }

  function looksOutOfStock(card) {
    var text = normalize(card.textContent || "");
    return text.indexOf("outofstock") !== -1 || text.indexOf("soldout") !== -1 || text.indexOf("unavailable") !== -1;
  }

  function isCardActiveForAutoAdd(card, config) {
    if (isAlwaysHiddenCard(card, config)) return false;
    if (!state.sweetStepShown && config.hideSweetsUntilStep && (isStandardSweetCard(card, config) || isFreeSweetCard(card, config))) {
      return false;
    }

    var wrap = getCardWrap(card, config);
    if (!isVisible(wrap)) return false;
    if (wrap.classList.contains("loop-goal-hidden")) return false;
    if (looksOutOfStock(card)) return false;

    var addBtn = card.querySelector(config.addButtonSelector);
    var plusBtn = card.querySelector(config.increaseButtonSelector);
    var qty = getCardQty(card, config);

    if (qty > 0) return true;
    if (isButtonEnabled(addBtn)) return true;
    if (isButtonEnabled(plusBtn)) return true;
    return false;
  }

  function getTagSetFromCard(card) {
    var raw =
      card.getAttribute("data-product-tags") ||
      card.getAttribute("data-tags") ||
      card.getAttribute("data-loop-tags") ||
      "";
    if (!raw) return null;

    var tags = raw
      .split(/[|,]/)
      .map(function (item) {
        return normalize(item);
      })
      .filter(Boolean);

    var setObj = {};
    for (var i = 0; i < tags.length; i += 1) setObj[tags[i]] = true;
    return setObj;
  }

  function getVariantAvailabilityMap(product) {
    var map = {};
    var variants = Array.isArray(product.variants) ? product.variants : [];
    for (var i = 0; i < variants.length; i += 1) {
      map[String(variants[i].id)] = !!variants[i].available;
    }
    return map;
  }

  function fetchProductMeta(card, config) {
    var handle = card.getAttribute("data-product-handle");
    if (!handle) return Promise.resolve(null);

    if (hasOwn(state.productByHandle, handle)) return Promise.resolve(state.productByHandle[handle]);
    if (state.productPromiseByHandle[handle]) return state.productPromiseByHandle[handle];

    var prebuiltTagSet = getTagSetFromCard(card);
    if (prebuiltTagSet) {
      state.productByHandle[handle] = {
        tags: prebuiltTagSet,
        available: true,
        variantAvailableById: {}
      };
      log(config, "Meta from card dataset", {
        handle: handle,
        tagCount: setSize(prebuiltTagSet)
      });
      return Promise.resolve(state.productByHandle[handle]);
    }

    state.productPromiseByHandle[handle] = fetch("/products/" + handle + ".js", {
      credentials: "same-origin"
    })
      .then(function (response) {
        if (!response.ok) throw new Error("Product unavailable: " + handle);
        return response.json();
      })
      .then(function (product) {
        var tags = {};
        var source = Array.isArray(product.tags) ? product.tags : String(product.tags || "").split(",");
        for (var i = 0; i < source.length; i += 1) {
          var normalized = normalize(source[i]);
          if (normalized) tags[normalized] = true;
        }

        state.productByHandle[handle] = {
          tags: tags,
          available: !!product.available,
          variantAvailableById: getVariantAvailabilityMap(product)
        };
        log(config, "Meta fetched", {
          handle: handle,
          available: !!product.available,
          tagCount: setSize(tags),
          variantCount: Array.isArray(product.variants) ? product.variants.length : 0
        });
        return state.productByHandle[handle];
      })
      .catch(function (error) {
        state.productByHandle[handle] = {
          tags: {},
          available: false,
          variantAvailableById: {}
        };
        log(config, "Meta fetch failed", {
          handle: handle,
          error: error && error.message ? error.message : "unknown"
        });
        return state.productByHandle[handle];
      })
      .finally(function () {
        delete state.productPromiseByHandle[handle];
      });

    return state.productPromiseByHandle[handle];
  }

  function isProductAvailableForCard(meta, card) {
    if (!meta || !meta.available) return false;
    var variantId = card.getAttribute("data-variant-id");
    if (!variantId) return true;

    if (!hasOwn(meta.variantAvailableById, String(variantId))) return true;
    return !!meta.variantAvailableById[String(variantId)];
  }

  function getTagKeysForSize(size, config) {
    return {
      standardTagSet: listToSet([normalize(config.tagPrefix + "_" + size)]),
      priorityTagSet: listToSet([normalize(config.tagPrefix + "_" + size + "_" + config.prioritySuffix)])
    };
  }

  function getFallbackTagSets(size, config) {
    var standard = [];
    var priority = [];

    var genericStandard = normalize(config.tagPrefix);
    var genericPriority = normalize(config.tagPrefix + "_" + config.prioritySuffix);
    if (genericStandard) standard.push(genericStandard);
    if (genericPriority) priority.push(genericPriority);

    if (size) {
      standard.push(normalize(config.tagPrefix + "_" + size));
      priority.push(normalize(config.tagPrefix + "_" + size + "_" + config.prioritySuffix));
    }

    var standardSet = listToSet(standard.filter(Boolean));
    var prioritySet = listToSet(priority.filter(Boolean));
    if (!setSize(standardSet) && !setSize(prioritySet)) return null;

    return {
      standardTagSet: standardSet,
      priorityTagSet: prioritySet
    };
  }

  function resolveBundleTagSets(bundleId, size, config) {
    var id = String(bundleId || "").toLowerCase();
    var rules = config.bundleRulesById[id] || [];
    var exact = [];
    var generic = [];
    var all = [];

    for (var i = 0; i < rules.length; i += 1) {
      all.push(rules[i]);
      if (rules[i].bundleSize === size) {
        exact.push(rules[i]);
      } else if (!rules[i].bundleSize) {
        generic.push(rules[i]);
      }
    }

    var chosen = [];
    if (size) {
      chosen = exact.length ? exact : generic;
    } else {
      chosen = generic.length ? generic : all;
    }
    if (!chosen.length) return null;

    var standardSet = {};
    var prioritySet = {};
    var maxTotal = 0;
    for (var n = 0; n < chosen.length; n += 1) {
      var rule = chosen[n];
      var key;
      for (key in rule.standardTagSet) {
        if (hasOwn(rule.standardTagSet, key)) standardSet[key] = true;
      }
      for (key in rule.priorityTagSet) {
        if (hasOwn(rule.priorityTagSet, key)) prioritySet[key] = true;
      }
      if (rule.maxTotal && (!maxTotal || rule.maxTotal < maxTotal)) {
        maxTotal = rule.maxTotal;
      }
    }

    return {
      standardTagSet: standardSet,
      priorityTagSet: prioritySet,
      maxTotal: maxTotal
    };
  }

  function triggerClick(button) {
    if (!button) return;
    try {
      button.dispatchEvent(new MouseEvent("mousedown", { bubbles: true, cancelable: true }));
      button.dispatchEvent(new MouseEvent("mouseup", { bubbles: true, cancelable: true }));
    } catch (_e) {}
    button.click();
  }

  function delay(ms) {
    return new Promise(function (resolve) {
      setTimeout(resolve, ms);
    });
  }

  async function waitForQtyChange(card, config, previousQty, direction) {
    var started = Date.now();
    while (Date.now() - started < config.actionTimeoutMs) {
      var currentQty = getCardQty(card, config);
      if (direction === "down") {
        if (currentQty < previousQty) return true;
      } else if (direction === "up") {
        if (currentQty > previousQty) return true;
      } else if (currentQty !== previousQty) {
        return true;
      }
      await delay(40);
    }
    return false;
  }

  async function addCardOnce(card, config) {
    var previousQty = getCardQty(card, config);
    if (previousQty > 0) {
      log(config, "Skip addCardOnce: already has qty", {
        handle: getCardHandle(card) || "(no-handle)",
        qty: previousQty
      });
      return 0;
    }

    return incrementCardOnce(card, config);
  }

  async function incrementCardOnce(card, config) {
    var handle = getCardHandle(card) || "(no-handle)";
    var previousQty = getCardQty(card, config);
    var addBtn = card.querySelector(config.addButtonSelector);
    var plusBtn = card.querySelector(config.increaseButtonSelector);
    var button = null;
    if (previousQty > 0 && isButtonEnabled(plusBtn)) {
      button = plusBtn;
    } else if (isButtonEnabled(addBtn)) {
      button = addBtn;
    } else if (isButtonEnabled(plusBtn)) {
      button = plusBtn;
    }
    if (!isButtonEnabled(button)) {
      log(config, "Skip incrementCardOnce: no enabled button", {
        handle: handle,
        qty: previousQty
      });
      return 0;
    }

    log(config, "Try incrementCardOnce", {
      handle: handle,
      qtyBefore: previousQty,
      action: button === addBtn ? "add-button" : "plus-button"
    });
    triggerClick(button);
    await delay(config.clickDelayMs);

    var changed = await waitForQtyChange(card, config, previousQty, "up");
    var qtyAfter = getCardQty(card, config);
    var delta = qtyAfter - previousQty;
    if (changed && delta < 1) delta = 1;
    log(config, "incrementCardOnce result", {
      handle: handle,
      changed: changed,
      qtyBefore: previousQty,
      qtyAfter: qtyAfter,
      delta: delta > 0 ? delta : 0
    });
    return delta > 0 ? delta : 0;
  }

  async function decreaseCardOnce(card, config) {
    var previousQty = getCardQty(card, config);
    if (previousQty < 1) return false;
    var decreaseBtn = card.querySelector(".loop-btn-input-decrease");
    if (!isButtonEnabled(decreaseBtn)) return false;

    triggerClick(decreaseBtn);
    await delay(config.clickDelayMs);
    return waitForQtyChange(card, config, previousQty, "down");
  }

  async function removeCardToZero(card, config) {
    var guard = 12;
    while (guard > 0 && getCardQty(card, config) > 0) {
      var changed = await decreaseCardOnce(card, config);
      if (!changed) break;
      guard -= 1;
    }
    return getCardQty(card, config) === 0;
  }

  function cardsPendingMeta(cards) {
    for (var i = 0; i < cards.length; i += 1) {
      var handle = cards[i].getAttribute("data-product-handle");
      if (handle && !hasOwn(state.productByHandle, handle)) return true;
    }
    return false;
  }

  async function ensureMeta(cards, config) {
    var tasks = [];
    for (var i = 0; i < cards.length; i += 1) {
      tasks.push(fetchProductMeta(cards[i], config));
    }
    await Promise.all(tasks);
  }

  async function applyAutoAdd(reason, config) {
    if (!config.enabled || state.applying || state.sweetStepShown) return;
    var cycleStartedAt = Date.now();
    var debugOpened = debugGroupStart(config, "Apply cycle: " + String(reason || "unknown"));

    var dom = queryDom(config);
    if (!dom || !dom.cards.length) {
      log(config, "Skip: loop root/cards not found", {
        hasDom: !!dom,
        cardCount: dom && dom.cards ? dom.cards.length : 0
      });
      debugGroupEnd(config, debugOpened);
      return;
    }

    var bundleId = detectBundleId(dom, config);
    var detectedSize = detectBundleSize(dom, config);
    var size = config.allowedSizeSet[detectedSize] ? detectedSize : 0;
    trace("context", {
      reason: reason,
      bundleId: bundleId || "(unknown)",
      detectedSize: detectedSize || "(unknown)",
      resolvedSize: size || "(unknown)",
      cards: dom.cards.length,
      currentQty: getCurrentBundleQty(dom, config)
    });
    log(config, "Context", {
      reason: reason,
      bundleId: bundleId || "(unknown)",
      detectedSize: detectedSize || "(unknown)",
      resolvedSize: size || "(unknown)"
    });
    log(config, "DOM snapshot", {
      cardCount: dom.cards.length,
      currentQty: getCurrentBundleQty(dom, config)
    });

    var tags = resolveBundleTagSets(bundleId, size, config);
    var tagSource = "bundle-rules";
    if (!tags && config.fallbackToSizeTags) {
      tags = getFallbackTagSets(size, config);
      tagSource = "fallback-to-size-tags";
    }
    if (!tags) {
      if (config.requireBundleRule) {
        var noRuleStamp = getApplyStampKey(bundleId, size || "nosize");
        if (!state.noRuleLoggedByStamp[noRuleStamp]) {
          log(config, "Skip: no tag rules for bundle", { bundleId: bundleId || "(unknown)", size: size || "(unknown)" });
          trace("skip: no tag rules", {
            bundleId: bundleId || "(unknown)",
            size: size || "(unknown)",
            requireBundleRule: !!config.requireBundleRule
          });
          state.noRuleLoggedByStamp[noRuleStamp] = true;
        }
        debugGroupEnd(config, debugOpened);
        return;
      }
      tags = getFallbackTagSets(size, config);
      tagSource = "fallback-no-required-rules";
    }
    if (!tags) {
      log(config, "Skip: no valid tags to apply", {
        bundleId: bundleId || "(unknown)",
        size: size || "(unknown)",
        reason: reason
      });
      trace("skip: no valid tags", {
        bundleId: bundleId || "(unknown)",
        size: size || "(unknown)"
      });
      debugGroupEnd(config, debugOpened);
      return;
    }
    trace("resolved tags", {
      source: tagSource,
      priorityTags: setToList(tags.priorityTagSet),
      standardTags: setToList(tags.standardTagSet),
      maxTotal: tags.maxTotal || 0
    });
    log(config, "Resolved tag sets", {
      source: tagSource,
      standardTags: setToList(tags.standardTagSet),
      priorityTags: setToList(tags.priorityTagSet),
      maxTotal: tags.maxTotal || 0
    });

    var targetTotal = tags.maxTotal || size || 0;
    var stampKey = getApplyStampKey(bundleId, targetTotal || "nosize");
    delete state.noRuleLoggedByStamp[stampKey];

    if (state.userInteracted && hasOwn(state.applyStampBySize, stampKey)) {
      log(config, "Skip: user already interacted", { size: size || "(unknown)", targetTotal: targetTotal || "(none)" });
      trace("skip: user already interacted", { stampKey: stampKey });
      debugGroupEnd(config, debugOpened);
      return;
    }

    var currentQty = getCurrentBundleQty(dom, config);
    if (targetTotal && currentQty >= targetTotal) {
      state.applyStampBySize[stampKey] = true;
      log(config, "Skip: bundle already filled", { targetTotal: targetTotal, currentQty: currentQty });
      trace("skip: bundle already filled", {
        size: size,
        targetTotal: targetTotal,
        currentQty: currentQty
      });
      debugGroupEnd(config, debugOpened);
      return;
    }

    var activeCards = dom.cards.filter(function (card) {
      return isCardActiveForAutoAdd(card, config);
    });
    log(config, "Active cards scan", {
      allCards: dom.cards.length,
      activeCards: activeCards.length
    });

    if (!activeCards.length) {
      debugGroupEnd(config, debugOpened);
      return;
    }

    state.applying = true;
    dom.root.classList.add(config.loadingClass);

    try {
      if (cardsPendingMeta(activeCards)) {
        log(config, "Meta preload start", { cards: activeCards.length });
        await ensureMeta(activeCards, config);
        log(config, "Meta preload complete", { cachedHandles: Object.keys(state.productByHandle).length });
      }

      var priorityCards = [];
      var standardCards = [];
      var fallbackCards = [];
      var priorityEligibleCards = [];
      var standardEligibleCards = [];
      var classificationRows = [];

      for (var i = 0; i < activeCards.length; i += 1) {
        var card = activeCards[i];
        var handle = card.getAttribute("data-product-handle");
        var qty = getCardQty(card, config);
        var alreadySelected = qty > 0;
        var cardKey = getCardKey(card);
        var variantId = getCardVariantId(card);
        var row = {
          key: cardKey,
          handle: handle || "(no-handle)",
          variantId: variantId || "",
          qty: qty,
          qtyAfter: qty,
          alreadySelected: alreadySelected,
          available: false,
          productTagCount: 0,
          productTags: "",
          matchedPriority: false,
          matchedPriorityCount: 0,
          matchedPriorityTags: "",
          matchedStandard: false,
          matchedStandardCount: 0,
          matchedStandardTags: "",
          decision: "skip",
          queueType: "none",
          queuePosition: 0,
          addResult: "not-attempted",
          reason: ""
        };
        if (!isCardActiveForAutoAdd(card, config)) {
          row.reason = "inactive-on-second-check";
          classificationRows.push(row);
          continue;
        }

        var meta = state.productByHandle[handle];
        var available = isProductAvailableForCard(meta, card);
        row.available = !!available;
        var productTags = setToList((meta && meta.tags) || {});
        row.productTagCount = productTags.length;
        row.productTags = tagsToText(productTags);
        if (!available) {
          row.reason = "not-available";
          classificationRows.push(row);
          continue;
        }

        var matchedPriorityTags = setIntersectList(meta.tags, tags.priorityTagSet);
        var matchedStandardTags = setIntersectList(meta.tags, tags.standardTagSet);
        var matchedPriority = matchedPriorityTags.length > 0;
        var matchedStandard = matchedStandardTags.length > 0;
        row.matchedPriority = matchedPriority;
        row.matchedPriorityCount = matchedPriorityTags.length;
        row.matchedPriorityTags = tagsToText(matchedPriorityTags);
        row.matchedStandard = matchedStandard;
        row.matchedStandardCount = matchedStandardTags.length;
        row.matchedStandardTags = tagsToText(matchedStandardTags);

        if (matchedPriority) {
          priorityEligibleCards.push(card);
          if (alreadySelected) {
            row.decision = "priority-selected";
            row.reason = "already-selected";
          } else {
            priorityCards.push(card);
            row.decision = "priority";
          }
        } else if (matchedStandard) {
          standardEligibleCards.push(card);
          if (alreadySelected) {
            row.decision = "standard-selected";
            row.reason = "already-selected";
          } else {
            standardCards.push(card);
            row.decision = "standard";
          }
        } else if (targetTotal && !alreadySelected) {
          fallbackCards.push(card);
          row.decision = "fallback";
          row.reason = "fallback-candidate";
        } else {
          row.reason = "no-tag-match";
        }
        classificationRows.push(row);
      }

      var orderedEntries = [];
      var remaining = targetTotal ? targetTotal - getCurrentBundleQty(dom, config) : priorityCards.length + standardCards.length;
      var totalAdded = 0;
      var addedHandles = [];
      var failedHandles = [];
      var executionRows = [];
      var orderRows = [];
      for (var q = 0; q < priorityCards.length; q += 1) {
        var priorityCard = priorityCards[q];
        var priorityEntry = {
          card: priorityCard,
          key: getCardKey(priorityCard),
          handle: getCardHandle(priorityCard) || "(no-handle)",
          variantId: getCardVariantId(priorityCard) || "",
          type: "priority",
          position: q + 1
        };
        orderedEntries.push(priorityEntry);
        orderRows.push({
          key: priorityEntry.key,
          handle: priorityEntry.handle,
          variantId: priorityEntry.variantId,
          type: priorityEntry.type,
          position: priorityEntry.position
        });
      }
      for (var w = 0; w < standardCards.length; w += 1) {
        var standardCard = standardCards[w];
        var standardEntry = {
          card: standardCard,
          key: getCardKey(standardCard),
          handle: getCardHandle(standardCard) || "(no-handle)",
          variantId: getCardVariantId(standardCard) || "",
          type: "standard",
          position: priorityCards.length + w + 1
        };
        orderedEntries.push(standardEntry);
        orderRows.push({
          key: standardEntry.key,
          handle: standardEntry.handle,
          variantId: standardEntry.variantId,
          type: standardEntry.type,
          position: standardEntry.position
        });
      }
      if (targetTotal) {
        for (var fb = 0; fb < fallbackCards.length; fb += 1) {
          var fallbackCard = fallbackCards[fb];
          var fallbackEntry = {
            card: fallbackCard,
            key: getCardKey(fallbackCard),
            handle: getCardHandle(fallbackCard) || "(no-handle)",
            variantId: getCardVariantId(fallbackCard) || "",
            type: "fallback",
            position: priorityCards.length + standardCards.length + fb + 1
          };
          orderedEntries.push(fallbackEntry);
          orderRows.push({
            key: fallbackEntry.key,
            handle: fallbackEntry.handle,
            variantId: fallbackEntry.variantId,
            type: fallbackEntry.type,
            position: fallbackEntry.position
          });
        }
      }
      var queueByKey = {};
      for (var qb = 0; qb < orderRows.length; qb += 1) {
        queueByKey[orderRows[qb].key] = orderRows[qb];
      }
      for (var cr = 0; cr < classificationRows.length; cr += 1) {
        var queued = queueByKey[classificationRows[cr].key];
        if (queued) {
          classificationRows[cr].queueType = queued.type;
          classificationRows[cr].queuePosition = queued.position;
        }
      }
      var priorityOrderValid = isPriorityOrderValid(orderRows);
      trace("ordered queue", {
        total: orderedEntries.length,
        priority: priorityCards.length,
        standard: standardCards.length,
        fallback: fallbackCards.length,
        priorityOrderValid: priorityOrderValid,
        order: orderRows
      });
      if (!priorityOrderValid) {
        trace("priority order violation", { order: orderRows });
      }

      if (!orderedEntries.length) {
        log(config, "No cards matched tag sets", {
          bundleId: bundleId || "(unknown)",
          size: size || "(unknown)"
        });
      }
      log(config, "Classification rows", classificationRows);

      log(config, "Apply", {
        reason: reason,
        bundleId: bundleId || "(unknown)",
        size: size || "(unknown)",
        targetTotal: targetTotal || "(none)",
        remaining: remaining,
        priority: priorityCards.length,
        standard: standardCards.length,
        fallback: fallbackCards.length,
        priorityTagCount: setSize(tags.priorityTagSet),
        standardTagCount: setSize(tags.standardTagSet)
      });

      var classificationByKey = {};
      for (var cb = 0; cb < classificationRows.length; cb += 1) {
        var rowKey = classificationRows[cb].key;
        if (!classificationByKey[rowKey]) classificationByKey[rowKey] = [];
        classificationByKey[rowKey].push(classificationRows[cb]);
      }

      for (var n = 0; n < orderedEntries.length; n += 1) {
        if (targetTotal) {
          remaining = targetTotal - getCurrentBundleQty(dom, config);
          if (remaining <= 0) break;
        }
        if (state.userInteracted && hasOwn(state.applyStampBySize, stampKey)) break;
        var targetEntry = orderedEntries[n];
        var targetCard = targetEntry.card;
        var targetHandle = targetEntry.handle;
        var targetKey = targetEntry.key;
        var qtyBefore = getCardQty(targetCard, config);
        var added = await addCardOnce(targetCard, config);
        var qtyAfter = getCardQty(targetCard, config);
        executionRows.push({
          step: n + 1,
          key: targetKey,
          handle: targetHandle,
          variantId: targetEntry.variantId,
          queueType: targetEntry.type,
          qtyBefore: qtyBefore,
          qtyAfter: qtyAfter,
          changed: added > 0
        });
        if (classificationByKey[targetKey] && classificationByKey[targetKey].length) {
          var appliedRow = classificationByKey[targetKey].shift();
          appliedRow.addResult = added > 0 ? "added" : "failed";
          appliedRow.qtyAfter = qtyAfter;
        }
        if (added > 0) {
          totalAdded += added;
          if (targetTotal) remaining = targetTotal - getCurrentBundleQty(dom, config);
          addedHandles.push(targetHandle);
          trace("added", {
            handle: targetHandle,
            step: n + 1,
            remaining: targetTotal ? remaining : "(no-size-limit)"
          });
        } else {
          failedHandles.push(targetHandle);
          trace("not added", {
            handle: targetHandle,
            step: n + 1
          });
        }
      }

      log(config, "Apply complete", {
        bundleId: bundleId || "(unknown)",
        size: size || "(unknown)",
        targetTotal: targetTotal || "(none)",
        added: totalAdded,
        addedHandles: addedHandles,
        failedHandles: failedHandles,
        durationMs: Date.now() - cycleStartedAt
      });
      trace("apply complete", {
        bundleId: bundleId || "(unknown)",
        size: size || "(unknown)",
        targetTotal: targetTotal || "(none)",
        added: totalAdded,
        addedHandles: addedHandles,
        failedHandles: failedHandles,
        durationMs: Date.now() - cycleStartedAt
      });
      state.applyStampBySize[stampKey] = true;
    } finally {
      state.applying = false;
      dom.root.classList.remove(config.loadingClass);
      debugGroupEnd(config, debugOpened);
    }
  }

  function scheduleApply(reason, config, delayMs) {
    clearTimeout(state.scheduledTimer);
    log(config, "Schedule apply", {
      reason: reason,
      delayMs: delayMs
    });
    state.scheduledTimer = setTimeout(function () {
      applyAutoAdd(reason, config);
    }, delayMs);
  }

  function bindInteractionTracking(config) {
    function sweetTriggerCaptureHandler(event) {
      tryInterceptSweetStepTrigger(event, config);
    }

    document.addEventListener("mousedown", sweetTriggerCaptureHandler, true);
    try {
      document.addEventListener("touchstart", sweetTriggerCaptureHandler, { capture: true, passive: false });
    } catch (_e) {
      document.addEventListener("touchstart", sweetTriggerCaptureHandler, true);
    }
    document.addEventListener("click", sweetTriggerCaptureHandler, true);

    document.addEventListener(
      "click",
      function (event) {
        if (tryInterceptSweetStepTrigger(event, config)) return;
        if (tryHandleSweetStepCheckoutTrigger(event, config)) return;

        var target = event.target;
        if (!target || !target.closest) return;

        var viewCartTrigger = target.closest(".loop-bundle-view-cart-btn, .loop-selected-bundle-title");
        if (viewCartTrigger) {
          runFrequencySafe(function () {
            scheduleFrequencyRestoreBurst("view-cart-open", config, [120, 360, 700, 1200, 1800]);
            freqDebug("view-cart-trigger", {
              trusted: event.isTrusted !== false,
              reason: "click"
            });
            return true;
          });
        }

        if (event.isTrusted === false) return;

        var frequencyBtn = closestSafe(target, config.frequencyButtonSelector);
        if (frequencyBtn) {
          runFrequencySafe(function () {
            saveFrequencyPreference(frequencyBtn, config);
            scheduleFrequencyRestore("frequency-click", config, config.clickDelayMs + 160);
            freqDebug("frequency-click", {
              label: normalizeFrequencyLabel(getFrequencyButtonText(frequencyBtn))
            });
            return true;
          });
        }

        var root = document.querySelector(config.rootSelector);
        if (!root || !root.contains(target)) return;

        var touchedControls = target.closest(
          config.addButtonSelector + ", " + config.increaseButtonSelector + ", .loop-btn-input-decrease, .goal-box"
        );
        if (touchedControls) {
          state.userInteracted = true;
          log(config, "User interaction detected", {
            type: "product-control",
            target: target.className || target.tagName || "unknown"
          });
          if (state.sweetStepShown) {
            scheduleSweetSync(config, config.clickDelayMs + 60);
          }
        }

        var sizeBtn = target.closest(config.sizeClickSelector);
        if (sizeBtn) {
          state.userInteracted = false;
          log(config, "Bundle size button clicked", {
            text: (sizeBtn.textContent || "").trim()
          });
          scheduleApply("size-change", config, 80);
          scheduleFrequencyRestore("size-change", config, config.clickDelayMs + 220);
          if (state.sweetStepShown) {
            scheduleSweetSync(config, config.clickDelayMs + 80);
          }
        }
      },
      true
    );
  }

  function startObserver(config) {
    if (state.observerStarted) return;
    state.observerStarted = true;
    log(config, "MutationObserver started", {
      debounceMs: config.mutationDebounceMs
    });

    var observer = new MutationObserver(function () {
      if (state.applying || state.visibilityApplying) return;
      scheduleDefaultVisibility(config, config.mutationDebounceMs);
      scheduleApply("mutation", config, config.mutationDebounceMs);
      runFrequencySafe(function () {
        scheduleFrequencyRestore("mutation", config, config.mutationDebounceMs + 80);
        return true;
      });
      if (state.sweetStepShown) {
        scheduleSweetSync(config, config.mutationDebounceMs);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class", "style", "value", "aria-current", "hidden"]
    });
  }

  function bootstrap(config) {
    log(config, "Bootstrap start", {
      retryCount: state.retryCount
    });
    var dom = queryDom(config);
    if (!dom || !dom.cards.length) {
      log(config, "Bootstrap waiting for Loop DOM", {
        hasDom: !!dom,
        cards: dom && dom.cards ? dom.cards.length : 0,
        retryCount: state.retryCount
      });
      if (state.retryCount < config.retryLimit) {
        state.retryCount += 1;
        setTimeout(function () {
          bootstrap(config);
        }, config.bootstrapDelayMs);
      }
      return;
    }

    ensureSweetStyles(config);
    applyDefaultCardVisibility(dom, config);
    Promise.resolve(applyAutoAdd("initial", config)).finally(function () {
      window.__LOOP_AUTOADDONS_INITIAL_APPLY_DONE = true;
      runFrequencySafe(function () {
        saveFrequencyPreference(null, config, dom);
        scheduleFrequencyRestore("initial", config, config.frequencyRestoreDelayMs);
        return true;
      });
    });
    bindInteractionTracking(config);
    startObserver(config);
    window.addEventListener("pageshow", function () {
      runFrequencySafe(function () {
        scheduleFrequencyRestore("pageshow", config, 80);
        return true;
      });
    });
    log(config, "Bootstrap done", {
      cards: dom.cards.length
    });
  }

  var config = getRuntimeConfig();
  log(config, "Runtime config", {
    enabled: !!config.enabled,
    allowedSizes: config.allowedSizes,
    bundleRuleCount: config.bundleRules ? config.bundleRules.length : 0,
    requireBundleRule: !!config.requireBundleRule,
    fallbackToSizeTags: !!config.fallbackToSizeTags,
    sweetsStepEnabled: !!config.sweetsStepEnabled,
    hideSweetsUntilStep: !!config.hideSweetsUntilStep,
    sweetsVariantIds: config.sweetsVariantIds,
    sweetsAutoSelectVariantIds: config.sweetsAutoSelectVariantIds,
    sweetsFreeVariantId: config.sweetsFreeVariantId,
    alwaysHiddenVariantIds: config.alwaysHiddenVariantIds,
    sweetsStepTriggerSelector: config.sweetsStepTriggerSelector,
    frequencyButtonSelector: config.frequencyButtonSelector
  });
  if (!config.enabled) return;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      bootstrap(config);
    });
  } else {
    bootstrap(config);
  }
})();
